// console.log('%c[JollyChef Custom Script] - Script Loaded and Executing...', 'color: #4CAF50; font-weight: bold;');
// custom.js

// 拦截 quick-add 按钮点击，直接跳转到详情页
document.addEventListener('click', function(e) {
    const link = e.target.closest('[data-direct-link="true"]');
    if (link) {
        e.stopImmediatePropagation();
        window.location.href = link.href;
    }
}, true);

	// Factory direct DDP & customization pricing (inquire table) toggle
	document.addEventListener('click', function (e) {
	    const toggleEl = e.target.closest('[data-factory-pricing-toggle]');
	    if (!toggleEl) return;

	    const scope = toggleEl.closest('.subscription-v2-wrapper') || document;
	    const tableWrapper = scope.querySelector('.product__tiered-pricing-inquire-wrapper');
	    if (!tableWrapper) return;

	    if (tableWrapper.dataset.factoryPricingAvailable !== 'true') return;
	    e.preventDefault();
	    const isOpen = tableWrapper.dataset.factoryPricingOpen === 'true';

	    tableWrapper.dataset.factoryPricingOpen = isOpen ? 'false' : 'true';
	    tableWrapper.classList.toggle('is-open', !isOpen);
	});

let G_currentVariant = null;
let G_lastClickedOptionGroup = null; // Track which option group was clicked
let G_isInitialLoad = true; // Track if this is the first load

// lb-volume-discount (app) can update table content dynamically (including per-variant tiers).
// Prefer the table within #lb-volume-discount when available, and avoid relying on visibility
// since we may hide the app block while still using its DOM as the source of truth.
function getLbVolumeDiscountSourceTable() {
    const container = document.querySelector('#lb-volume-discount');
    if (container) {
        const tableInContainer = container.querySelector('lb-volume-discount table') || container.querySelector('table');
        if (tableInContainer) return tableInContainer;
    }

    const tables = Array.from(document.querySelectorAll('lb-volume-discount table'));
    if (!tables.length) return null;

    const candidate = tables.find((t) => {
        if (!t || !t.isConnected) return false;
        if (t.closest && t.closest('[hidden], [aria-hidden="true"]')) return false;
        const style = window.getComputedStyle(t);
        return !(style && style.display === 'none');
    });

    return candidate || tables[0] || null;
}

function hasLbVolumeDiscountData() {
    const volumeSourceTable = getLbVolumeDiscountSourceTable();
    if (!volumeSourceTable) return false;

    const trs = volumeSourceTable.querySelectorAll('tbody tr');
    for (let i = 0; i < trs.length; i++) {
        const tds = trs[i].querySelectorAll('td');
        if (tds.length < 2) continue;
        const discountStr = ((tds[1].textContent || tds[1].innerText || '').trim() || '').replace('%', '');
        const discount = parseFloat(discountStr) || 0;
        if (discount > 0) return true;
    }
    return false;
}

// When lb-volume-discount renders/updates after variant change, keep dependent UI in sync.
let G_lbVolumeObserver = null;
let G_lbVolumeObservedNode = null;
let G_lbVolumeUpdateTimer = null;
let G_lbVolumeLastPriceKey = null;

function refreshLbVolumeDiscountDependentUI() {
    if (!G_currentVariant || !G_currentVariant.options) return;

    const lastOption = G_currentVariant.options[G_currentVariant.options.length - 1] || '';
    const isCarton = lastOption.toLowerCase().includes('carton');

    // Check if lb-volume-discount exists and has valid discount tiers
    const hasLbVolumeDiscount = hasLbVolumeDiscountData();

    const twoOrMoreWrapperEls = document.querySelectorAll('.subscription-v2-wrapper .product__two-or-more-wrapper');
    if (twoOrMoreWrapperEls.length > 0) {
        twoOrMoreWrapperEls.forEach(el => {
            el.style.display = (isCarton && !hasLbVolumeDiscount) ? '' : 'none';
        });
    }

    const tieredPricingWrapperEls = document.querySelectorAll('.subscription-v2-wrapper .product__tiered-pricing-wrapper');
    if (tieredPricingWrapperEls.length > 0) {
        tieredPricingWrapperEls.forEach(el => {
            el.style.display = (isCarton && hasLbVolumeDiscount) ? '' : 'none';
        });
    }
}

function scheduleRefreshLbVolumeDiscountDependentUI() {
    if (G_lbVolumeUpdateTimer) return;
    G_lbVolumeUpdateTimer = setTimeout(() => {
        G_lbVolumeUpdateTimer = null;
        refreshLbVolumeDiscountDependentUI();

        // Keep main price UI in sync as well (lb-volume-discount can update asynchronously).
        if (typeof updateDisplayPrice === 'function') {
            const pd = typeof getPriceForCurrentState === 'function' ? getPriceForCurrentState() : null;
            if (pd) {
                const key = [
                    G_currentVariant && G_currentVariant.id ? G_currentVariant.id : '',
                    pd.price,
                    pd.compare_at_price,
                    pd.discount && pd.discount.type ? pd.discount.type : '',
                    pd.discount && pd.discount.value != null ? pd.discount.value : ''
                ].join('|');
                if (key !== G_lbVolumeLastPriceKey) {
                    G_lbVolumeLastPriceKey = key;
                    updateDisplayPrice();
                }
            } else {
                updateDisplayPrice();
            }
        }
    }, 60);
}

function ensureLbVolumeDiscountObserver() {
    if (typeof MutationObserver === 'undefined') return;

    const container = document.querySelector('#lb-volume-discount') || document.querySelector('lb-volume-discount');
    if (!container) return;

    const table = getLbVolumeDiscountSourceTable();
    const nodeToObserve = table || container;
    if (G_lbVolumeObservedNode === nodeToObserve && G_lbVolumeObserver) return;

    if (G_lbVolumeObserver) G_lbVolumeObserver.disconnect();
    G_lbVolumeObservedNode = nodeToObserve;

    G_lbVolumeObserver = new MutationObserver(() => {
        const latestTable = getLbVolumeDiscountSourceTable();
        if (latestTable && latestTable !== G_lbVolumeObservedNode) {
            ensureLbVolumeDiscountObserver();
        }
        scheduleRefreshLbVolumeDiscountDependentUI();
    });

    G_lbVolumeObserver.observe(nodeToObserve, { childList: true, subtree: true, characterData: true });
}

// 封装产品数据获取方法
function getProductDataAndMeta(context = document) {
    const productJsonElement = context.querySelector('[data-product-json]');
    const productMetaJsonElement = context.querySelector('[data-product-meta-json]');
    let productData = null;
    let productMetaData = null;
    let productMetaMap = {};

    if (productJsonElement) {
        try {
            productData = JSON.parse(productJsonElement.textContent);
            productData.variants = productData.variants;
        } catch (e) {
        }
    } else {
    }

    if (productMetaJsonElement) {
        try {
            productMetaData = JSON.parse(productMetaJsonElement.textContent);
            productMetaData.forEach(item => {
                productMetaMap[item.id] = item.prodMeta;
            });
        } catch (e) {
        }
    }

    return { productData, productMetaData, productMetaMap };
}

// Helper to parse quantity from option string (extracts minimum number found)
function getQuantityFromOption(optionValue) {
    if (!optionValue) return NaN;

    // 1. 处理斜杠，取第一部分
    let text = String(optionValue).split('/')[0];

    // 2. 如果包含括号，优先检查括号内的内容
    // 例如 "8oz (1000/carton)" -> text 是 "8oz (1000"
    // 我们需要看是否存在 "(数字" 的模式，这通常表示真正的数量
    const parenMatch = text.match(/\(\s*(\d+)/);
    if (parenMatch) {
        return parseFloat(parenMatch[1]);
    }

    // 3. 如果包含 "and"，说明是组合套装，例如 "1440 Forks and 960 Spoons"
    // 这种情况下，通常取最小值（或者这里您需要确认逻辑，目前取最小值符合您的 "取最小的480" 要求）
    if (text.includes(' and ') || text.includes(' & ')) {
        const matches = text.match(/(\d+(\.\d+)?)/g);
        if (matches && matches.length > 0) {
            const numbers = matches.map(n => parseFloat(n));
            return Math.min(...numbers);
        }
    }

    // 4. 常规情况：排除掉显然是规格的数字（如 8oz, 500ml）
    // 策略：如果一个数字后面紧跟着 oz, ml, g, kg, lb 等单位，它可能是规格而不是数量
    // 但正则比较复杂。
    // 一个简单的策略是：如果存在多个数字，且其中一个数字很大（比如 > 50），通常取大的那个。
    // 但这对于 "Pack of 2" 又不适用。

    // 更稳健的策略：
    // 如果数字后面紧跟 "oz", "ml", "inch", "mm", "cm"，则忽略该数字（除非它是唯一的数字）。

    const regex = /(\d+(\.\d+)?)\s*(oz|ml|inch|mm|cm|g|kg|lbs?|lb)?/gi;
    let match;
    const candidates = [];

    while ((match = regex.exec(text)) !== null) {
        const num = parseFloat(match[1]);
        const unit = match[3]; // 捕获到的单位

        if (unit) {
            // 是规格数字，标记为低优先级，或者直接忽略？
            // 暂存，但标记为 specification
             candidates.push({ val: num, isSpec: true });
        } else {
             candidates.push({ val: num, isSpec: false });
        }
    }

    if (candidates.length === 0) return NaN;

    // 过滤掉是 Spec 的数字
    const nonSpecCandidates = candidates.filter(c => !c.isSpec);

    if (nonSpecCandidates.length > 0) {
        // 如果有非规格数字
        // 再次判断：如果是多个非规格数字，比如 "Pack of 2"，通常取那个。
        // 但如果没有明确规则，我们只能回退到旧逻辑或者根据数值大小判断。

        // 针对 "8oz (1000...)" 这种其实已经在步骤 2 处理了。
        // 这里处理像 "1000 Pcs 8oz" 这种没括号的情况。
        // "1000" (no spec), "8" (spec: oz) -> 取 1000。
        
        // 如果剩下多个数字，例如 "Pack of 2"，我们取其中明确是数量的。
        // 对于 "Pack of 2"，matches 是 ["2"]。
        // 对于 "2 Packs of 50"，matches 是 ["2", "50"]。应该取总数 100 还是 50？
        // 假设您的数据通常是单层级的。
        
        // 结合您的需求：
        // "1440 Forks and ... 480 Knives" -> 包含 'and'，已在步骤3处理。
        // "8oz (1000/carton)" -> 包含括号，已在步骤2处理。
        
        // 剩下的可能是 "3000/Case" -> ["3000"]
        // "100 Sets" -> ["100"]
        // "Pack of 2" -> ["2"]
        
        // 如果有多个数字且没有 'and' 也没有括号，且都不是规格单位：
        // 比如 "20 x 50" -> 可能是 1000。但这里 split('/') 后只剩 "20 x 50"。
        // 这种复杂情况暂不深究，按照旧逻辑取最小值或者最大值？
        // "Pack of 2" (2) vs "200 Pcs" (200).
        // 如果同时出现，比如 "Pack of 2 (200 pcs total)" -> 步骤2处理了括号。
        
        // 简单回退：如果有多个候选，取最大值？
        // 不，"Pack of 2" 是 2。
        // "1000 Pcs" 是 1000。
        // 如果一个字符串里只有数字，没有 'and'，通常就是一个数量。
        
        // 修正逻辑：对于剩余的 candidates，我们取第一个？或者最小值？
        // 旧逻辑是取最小值。对于 "Pack of 2" 是对的。
        // 对于 "1000 Pcs" 是对的。
        // 只要排除了 "8oz"，剩下 "1000"，最小值就是 1000。
        
        // 所以逻辑是：取所有 **非规格** 数字的 **最小值**。
        const values = nonSpecCandidates.map(c => c.val);
        return Math.min(...values);
    } else {
        // 如果全是规格数字（例如只写了 "8oz"），那就只能返回这个数字了（虽然它可能是错的，但没得选）
        // 或者返回 NaN?
        // 旧逻辑会返回 8。
        const values = candidates.map(c => c.val);
        return Math.min(...values);
    }
}

// 变体切换处理方法，始终从全局缓存读取数据，避免作用域残留
function handleVariantChange(event, contextKey = 'main') {

    const cache = (typeof window !== 'undefined' && window.ProductContextCache && window.ProductContextCache[contextKey]) || {};
    const { productData, productMetaMap, productMetaData } = cache;
    console.log("变体切换触发", event, productData, productMetaMap, productMetaData);
    const subscriptionForm = document.querySelector('[data-subscription-form]');
    const subscribeStatus = subscriptionForm?.querySelector('[data-subscription-option]:checked')?.value
        ?? subscriptionForm?.querySelector('[data-subscription-option]')?.value;
    const newVariant = event ? event.detail.variant : G_currentVariant;
    console.log("New Variant:", newVariant);

    if (!newVariant) {
        // Always remove animation before returning
        setTimeout(() => {
            removeVariantGroupAnimation();
        }, 150);
        return;
    }
    if (!productData || !productData.variants) {
        // Always remove animation before returning
        setTimeout(() => {
            removeVariantGroupAnimation();
        }, 150);
        return;
    }

    const productThumbnails = document.querySelector('.above-mobile .product-thumbnails__items');
    const productThumbnailsMobile = document.querySelector('.below-mobile .product-thumbnails__items');
    const thumbnailItems = productThumbnails ? Array.from(productThumbnails.children) : [];
    const thumbnailItemsMobile = productThumbnailsMobile ? Array.from(productThumbnailsMobile.children) : [];


    const variantMediaIds = new Set(
        productData.variants
            .map(v => v.featured_media?.id)
            .filter(id => id)
    );

    productData.media.forEach((mediaItem, index) => {
        const isVariantMedia = variantMediaIds.has(mediaItem.id);
        const isCurrentVariantMedia = newVariant.featured_media?.id === mediaItem.id;

        const shouldHide = isVariantMedia && !isCurrentVariantMedia;

        if (thumbnailItems[index]) {
            thumbnailItems[index].classList.toggle('hidden', shouldHide);
        }
        if (thumbnailItemsMobile[index]) {
            thumbnailItemsMobile[index].classList.toggle('hidden', shouldHide);
        }
    });


    const breadcrumbsElement = document.querySelector('.breadcrumbs__current');
    // if (breadcrumbsElement) {
    //     if (newVariant.sku) {
    //         breadcrumbsElement.innerHTML = '';
    //     } else {
    //         breadcrumbsElement.innerHTML = '';
    //     }
    // }
    // if (newVariant.options.length <= 1) {
    //     return;
    // }
    const matchingVariants = productData.variants.filter(variant => {
        if (newVariant.options.length === 2) {
            return variant.option1 === newVariant.option1;
        } else if (newVariant.options.length === 3) {
            return variant.option1 === newVariant.option1 && variant.option2 === newVariant.option2;
        }
        else if (newVariant.options.length === 1) {
            return true;
        }
    });
    if (matchingVariants.length === 0) {
        document.querySelectorAll('.variant-item-quantity-price').forEach(el => el.innerHTML = '');
        document.querySelectorAll('.variant-item-quantity-price-per-num').forEach(el => el.innerHTML = '');
        document.querySelectorAll('.variant-item-quantity-price-per-flag').forEach(el => {
            if (el) el.innerHTML = '';
        });
        // Always remove animation before returning
        setTimeout(() => {
            removeVariantGroupAnimation();
        }, 150);
        return;
    }
    let highestMatchingVariantUnitPrice = 0;
    matchingVariants.forEach(variant => {
        if (!variant.available) return;
        const quantity = getQuantityFromOption(variant.options[variant.options.length - 1]);
        if (!isNaN(quantity) && quantity > 0) {
            const unitPrice = variant.price / quantity;
            if (highestMatchingVariantUnitPrice < unitPrice) {
                highestMatchingVariantUnitPrice = unitPrice;
            }
        }
    });
    const variantItems = document.querySelectorAll('.variant-item-quantity-price');
    const variantPricePer = document.querySelectorAll('.variant-item-quantity-price-per-num');
    const variantPricePerFlag = document.querySelectorAll('.variant-item-quantity-price-per-flag');
    const variantOptionQuantity = document.querySelectorAll('.variant-option-quantity');
    variantOptionQuantity.forEach(el => {
        el.style.display = 'flex';
    });

    // Add flag updating class before price calculation
    variantPricePerFlag.forEach(flag => {
        if (flag) flag.classList.add('flag-updating');
    });

    const priceNoSub = document.querySelectorAll('.price_no_sub');
    const priceWithSub = document.querySelectorAll('.price_with_sub');
    priceNoSub.forEach(el => {
        if (el) el.innerHTML = formatMoney(newVariant.price);
    });
    priceWithSub.forEach(el => {
        if (el) el.innerHTML = formatMoney(newVariant.selling_plan_allocations.length > 0 ? newVariant.selling_plan_allocations[0].price : newVariant.price);
    });


    const priceData = getPriceForCurrentState();

    let lastAvailableIndex = -1;
    for (let i = matchingVariants.length - 1; i >= 0; i--) {
        if (matchingVariants[i].available) {
            lastAvailableIndex = i;
            break;
        }
    }
    let productLabelQuantity = document.querySelector('.product__label__quantity span');
    let productHeaderPerPrice = document.querySelector('.product_per_rating_price');

    // Update "2+ more" prices based on current selected variant (newVariant)
    // Calculate 5% discounted prices with floor rounding for "buy 2+" scenario
    const twoPlusMoreCartonPriceEls = document.querySelectorAll('.product__two-or-more-price');
    const twoPlusMoreEachPriceEls = document.querySelectorAll('.product__two-or-more-price-per');
    const currentVariantMeta = productMetaData && productMetaData.find(item => item.id === newVariant.id);

    // Calculate discounted price using floor rounding:
    // 1. Single item discount (cents) = floor(price * 0.05)
    // 2. Two items total discount = single discount * 2
    // 3. Two items discounted total = price * 2 - total discount
    // 4. Single discounted price = two items total / 2
    const singleDiscountCents = Math.floor(newVariant.price * 0.05);
    const twoItemsDiscountedTotal = newVariant.price * 2 - singleDiscountCents * 2;
    const discountedPriceCents = twoItemsDiscountedTotal / 2;
    const discountedCartonPrice = (discountedPriceCents / 100).toFixed(2);
    // Parse quantity from last option (e.g., "3000/carton" -> 3000)
    const lastOptionForQuantity = newVariant.options[newVariant.options.length - 1] || '';
    const quantityMatch = lastOptionForQuantity.split('/')[0];
    const quantityForCalc = getQuantityFromOption(lastOptionForQuantity) || 1;
    const discountedUnitPrice = (discountedPriceCents / 100 / quantityForCalc).toFixed(2);

    // Parse unit from option for "2 or more" price display (with or without space between number and unit)
    const twoMoreUnitMatch = quantityMatch.match(/^\d+\s*([a-zA-Z]+)/);
    let twoMorePriceUnit = 'Each';
    if (twoMoreUnitMatch && twoMoreUnitMatch[1]) {
        twoMorePriceUnit = twoMoreUnitMatch[1].charAt(0).toUpperCase() + twoMoreUnitMatch[1].slice(1).toLowerCase();
        if (twoMorePriceUnit.endsWith('s') && twoMorePriceUnit.length > 1) {
            twoMorePriceUnit = twoMorePriceUnit.slice(0, -1);
        }
    }

    if (twoPlusMoreCartonPriceEls.length > 0) {
        twoPlusMoreCartonPriceEls.forEach(el => {
            el.innerHTML = '$' + discountedCartonPrice + '<span> /carton</span>';
        });
    }
    if (twoPlusMoreEachPriceEls.length > 0) {
        twoPlusMoreEachPriceEls.forEach(el => {
            el.innerHTML = '$' + discountedUnitPrice + '/' + twoMorePriceUnit;
        });
    }

    // Update product specifications tag based on current selected variant
    const productSpecificationsTagEls = document.querySelectorAll('.product_specifications_tag');
    if (productSpecificationsTagEls.length > 0) {
        productSpecificationsTagEls.forEach(el => {
            el.innerHTML = currentVariantMeta && currentVariantMeta.metafields.product_specifications_tag ? currentVariantMeta.metafields.product_specifications_tag : '';
        });
    }

    // Update technical specs table when source is variant
    const variantSpecsTables = document.querySelectorAll('table[data-specs-source="variant"]');
    variantSpecsTables.forEach(table => {
        const specsData = currentVariantMeta?.metafields?.technical_specs_sku;
        if (specsData && Array.isArray(specsData)) {
            table.innerHTML = specsData.map(item =>
                `<tr><td>${item.key}</td><td>${item.value}</td></tr>`
            ).join('');
        }
    });

    // Show/hide carton-only wrappers based on whether variant is carton type (only within subscription-v2-wrapper)
    const lastOption = newVariant.options[newVariant.options.length - 1] || '';
    const isCarton = lastOption.toLowerCase().includes('carton');
    
    // Check if lb-volume-discount exists and has valid discount tiers
    let hasLbVolumeDiscount = false;
    const volumeSourceTable = getLbVolumeDiscountSourceTable();
    if (volumeSourceTable) {
        const trs = volumeSourceTable.querySelectorAll('tbody tr');
        for (let i = 0; i < trs.length; i++) {
            const tds = trs[i].querySelectorAll('td');
            if (tds.length >= 2) {
                const discountStr = ((tds[1].textContent || tds[1].innerText || '').trim() || '').replace('%', '');
                const discount = parseFloat(discountStr) || 0;
                if (discount > 0) {
                    hasLbVolumeDiscount = true;
                    break;
                }
            }
        }
    }

    const twoOrMoreWrapperEls = document.querySelectorAll('.subscription-v2-wrapper .product__two-or-more-wrapper');
    if (twoOrMoreWrapperEls.length > 0) {
        twoOrMoreWrapperEls.forEach(el => {
            el.style.display = (isCarton && !hasLbVolumeDiscount) ? '' : 'none';
        });
    }
    const tieredPricingWrapperEls = document.querySelectorAll('.subscription-v2-wrapper .product__tiered-pricing-wrapper');
    if (tieredPricingWrapperEls.length > 0) {
        tieredPricingWrapperEls.forEach(el => {
            el.style.display = (isCarton && hasLbVolumeDiscount) ? '' : 'none';
        });
    }

    // Update factory discount inquire table + bulk quote copy from variant metafield: custom.factory_discount_data
    const tieredPricingInquireWrapperEls = document.querySelectorAll('.subscription-v2-wrapper .product__tiered-pricing-inquire-wrapper');
    const factoryPricingContactEls = document.querySelectorAll('.subscription-v2-wrapper .custom_price_contact');
    if (tieredPricingInquireWrapperEls.length > 0 || factoryPricingContactEls.length > 0) {
        const rawFactoryDiscountData = currentVariantMeta?.metafields?.factory_discount_data;

        function parseFactoryDiscountData(raw) {
            if (!raw) return null;
            if (Array.isArray(raw)) return raw;
            if (typeof raw === 'string') {
                const trimmed = raw.trim();
                if (!trimmed) return null;
                try {
                    const parsed = JSON.parse(trimmed);
                    if (Array.isArray(parsed)) return parsed;
                } catch (e) {
                    return null;
                }
                return null;
            }
            if (typeof raw === 'object') {
                // Some metafields may come through as { value, type }
                if (raw.value != null) return parseFactoryDiscountData(raw.value);
                // Single entry object fallback
                if (raw.num || raw.discount || raw.customization) return [raw];
            }
            return null;
        }

        function escapeHtml(value) {
            return String(value == null ? '' : value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }

        function getUnitLabelFromOption(optionValue) {
            const quantityPart = String(optionValue || '').split('/')[0];
            const unitMatch = quantityPart.match(/^\s*\d+\s*([a-zA-Z]+)/);

            let unitLabel = 'Each';
            if (unitMatch && unitMatch[1]) {
                unitLabel = unitMatch[1].charAt(0).toUpperCase() + unitMatch[1].slice(1).toLowerCase();
                if (unitLabel.endsWith('s') && unitLabel.length > 1) {
                    unitLabel = unitLabel.slice(0, -1);
                }
            }

            return unitLabel;
        }

        const factoryDiscountData = parseFactoryDiscountData(rawFactoryDiscountData);
        const basePriceCents = newVariant && typeof newVariant.price === 'number' ? newVariant.price : NaN;

        const unitSizeParsed = getQuantityFromOption(lastOption);
        const unitSize = !isNaN(unitSizeParsed) && unitSizeParsed > 0 ? unitSizeParsed : 1;
        const unitLabel = getUnitLabelFromOption(lastOption);

        let rowsHtml = '';
        if (isCarton && factoryDiscountData && factoryDiscountData.length > 0 && !isNaN(basePriceCents)) {
            rowsHtml = factoryDiscountData
	                .map((tier) => {
	                    const label = tier && tier.num != null ? String(tier.num).trim() : '';
	                    if (!label) return '';

                    const discountRaw = tier && tier.discount != null ? String(tier.discount).trim() : '';
                    const discountPercent = parseFloat(discountRaw.replace('%', '')) || 0;

                    const customization = tier && tier.customization != null ? String(tier.customization).trim() : '';

                    const discountAmountCents = Math.floor(basePriceCents * (discountPercent / 100));
                    const tierPriceCents = basePriceCents - discountAmountCents;

                    const tierPrice = tierPriceCents / 100;
                    const tierUnitPrice = tierPrice / unitSize;

                    const priceStr = '$' + tierPrice.toFixed(2);
                    const unitPriceStr = '$' + tierUnitPrice.toFixed(2) + '/' + 'pc';

                    const badgeHtml = discountPercent > 0
                        ? `<div class="tiered-inquire-badge">-${discountPercent}%off</div>`
                        : '';

                    const customizationHtml = customization
                        ? `<span class="tiered-inquire-customization">${escapeHtml(customization)}</span>`
                        : '';

	                    const qtyLabelHtml = escapeHtml(label).replace(/\s+(cartons?)\s*$/i, '<br>$1');

	                    return `
	                        <tr>
	                          <td class="tiered-inquire-qty">${qtyLabelHtml}</td>
	                          <td>
	                            <div class="tiered-inquire-pricing-row">
	                              <div class="tiered-inquire-pricing-price-group">
	                                <span class="tiered-inquire-price">${priceStr}</span>
	                                <span class="tiered-inquire-unit-price">${unitPriceStr}</span>
	                              </div>
                              ${badgeHtml}
                            </div>
                          </td>
                          <td>${customizationHtml}</td>
                        </tr>
                      `;
                })
                .join('');
        }

        const hasFactoryPricing = isCarton && rowsHtml.trim() !== '';

	        // Bulk quote copy + description toggle
	        factoryPricingContactEls.forEach((contact) => {
	            contact.classList.toggle('custom_price_contact--factory-pricing', hasFactoryPricing);

	            const titleEl = contact.querySelector('.custom_price_contact_text_title');
	            const defaultTitle = titleEl?.dataset.defaultText || (titleEl?.textContent || '').trim();
	            const factoryTitleLine1 = titleEl?.dataset.factoryTitleLine1 || defaultTitle;
	            const factoryTitleLine2 = titleEl?.dataset.factoryTitleLine2 || '';

	            const descEl = contact.querySelector('.custom_price_contact_text_description');
	            const rightEl = contact.querySelector('.custom_price_contact_right');
	            const rightButtonEl = contact.querySelector('.custom_price_contact_right .custom_price_contact_button');
	            const defaultButtonText = rightButtonEl?.dataset.defaultText || (rightButtonEl?.textContent || '').trim();
	            if (rightEl && rightEl.dataset.defaultDisplay === undefined) {
	                rightEl.dataset.defaultDisplay = rightEl.style.display || '';
	            }
	            // Always show the right CTA area; only adjust button text when factory pricing exists.
	            if (rightEl) rightEl.style.display = rightEl.dataset.defaultDisplay || '';

	            if (hasFactoryPricing) {
	                if (titleEl) {
	                    titleEl.textContent = '';
	                    if (factoryTitleLine1) titleEl.append(document.createTextNode(factoryTitleLine1));
	                    if (factoryTitleLine2) titleEl.append(document.createElement('br'), document.createTextNode(factoryTitleLine2));
	                }
	                if (descEl) descEl.style.display = '';
	                if (rightButtonEl) rightButtonEl.textContent = defaultButtonText;
	            } else {
	                if (titleEl) titleEl.textContent = defaultTitle;
	                if (descEl) descEl.style.display = 'none';
	                if (rightButtonEl) rightButtonEl.textContent = defaultButtonText;
	            }
	        });

        // Inquire pricing table: render rows, but keep hidden until user clicks the description
        const variantIdStr = newVariant && newVariant.id != null ? String(newVariant.id) : '';
        tieredPricingInquireWrapperEls.forEach((wrapper) => {
            const tbody = wrapper.querySelector('tbody');
            if (!tbody) return;

            if (variantIdStr && wrapper.dataset.factoryPricingVariantId !== variantIdStr) {
                wrapper.dataset.factoryPricingVariantId = variantIdStr;
                // Keep open/closed state across variants; only close when data is unavailable.
            }

            if (!hasFactoryPricing) {
                wrapper.dataset.factoryPricingAvailable = 'false';
                wrapper.dataset.factoryPricingOpen = 'false';
                wrapper.classList.remove('is-open');
                return;
            }

            wrapper.dataset.factoryPricingAvailable = 'true';
            tbody.innerHTML = rowsHtml;

            const isOpen = wrapper.dataset.factoryPricingOpen === 'true';
            wrapper.classList.toggle('is-open', isOpen);
        });
    }

    matchingVariants.forEach((variant, index) => {
        let matchVariantItem = null;
        let matchvariantPricePer = null;
        let matchvariantPricePerFlag = null;
        let matchvariantV2Quantity = null;
        let matchVariantV2Price = null;
        let matchedQuantityText = '';


        variantOptionQuantity.forEach(el => {
            let matchEl = null;
            // console.log('======', el.querySelector('.variant-item-quantity-value').innerHTML, variant.options[variant.options.length - 1])

            const quantityValueEl = el.querySelector('.variant-item-quantity-value');
            const quantityValue = quantityValueEl ? quantityValueEl.innerHTML : '';
            if (quantityValue === variant.options[variant.options.length - 1]) {
                matchEl = el;

                matchVariantItem = el.querySelector('.variant-item-quantity-price');
                matchvariantPricePer = el.querySelector('.variant-item-quantity-price-per-num');
                matchvariantPricePerFlag = el.querySelector('.variant-item-quantity-price-per-flag');

                matchvariantV2Quantity = el.querySelector('.variant-item-quantity-v2-left');
                matchVariantV2Price = el.querySelector('.variant-item-quantity-v2-price');
                matchedQuantityText = quantityValue;
            }

        });

        if (index < variantItems.length) {
            // if (matchVariantItem === null) return;
            if (!matchVariantItem) {
                return;
            }
            let isIncluded = false;
            if (matchedQuantityText.includes(':')) {
                isIncluded = true;
            }
            const quantity = getQuantityFromOption(variant.options[variant.options.length - 1]);
            const unitPrice = !isNaN(quantity) && quantity > 0 ? variant.price / quantity : 0;
            const measuringUnit = productMetaMap && productMetaMap[variant.id]?.measuring_unit_singular || 'unit';

            // Check if current variant is carton type
            const variantLastOption = variant.options[variant.options.length - 1] || '';
            const isVariantCarton = variantLastOption.toLowerCase().includes('carton');

            // Get current cart quantity from quantity input (only for carton type)
            // Use more specific selector to find the product form quantity input, not cart quantity
            const productFormQuantityInput = document.querySelector('.product-form .quantity-input__input, .product-form [data-quantity-input], [id^="quantity-input-product-form-"]');
            const cartQuantity = productFormQuantityInput ? parseInt(productFormQuantityInput.value) || 1 : 1;

            // Determine discount: only apply bulk discount for carton type when quantity >= 2
            const isBulkDiscount = isVariantCarton && cartQuantity >= 2;
            const bulkDiscountPercent = 5; // 5% discount for 2+ cartons

            /**
             * ========== 买两件 Carton 95折逻辑 ==========
             *
             * 当前状态：已禁用 variant-item-quantity-price 和 variant-item-quantity-price-per-num 的折扣显示
             * 这两个元素始终显示原价，不受买两件折扣影响
             *
             * 【如何重新启用】
             * 1. 删除下面的 "始终显示原价" 代码块（标记为 [DISABLED BULK DISCOUNT]）
             * 2. 取消注释 "折扣价格显示" 代码块（标记为 [ENABLE BULK DISCOUNT]）
             * 3. 保存文件
             *
             * 注意：V2 价格元素 (matchVariantV2Price) 仍然会显示折扣价格
             */

            // [DISABLED BULK DISCOUNT] 始终显示原价 - 开始
            // variant-item-quantity-price 显示原价
            matchVariantItem.innerHTML = '$' + (variant.price / 100).toFixed(2);

            // variant-item-quantity-price-per-num 显示原单价
            if (!isIncluded) {
                let pricePerValueOriginal = unitPrice;
                if (pricePerValueOriginal > 100) {
                    pricePerValueOriginal = pricePerValueOriginal / 100;
                    matchvariantPricePer.innerHTML = '$' + pricePerValueOriginal.toFixed(2) + ' per ' + measuringUnit;
                } else {
                    matchvariantPricePer.innerHTML = '￠' + pricePerValueOriginal.toFixed(2) + ' per ' + measuringUnit;
                }
            }
            // [DISABLED BULK DISCOUNT] 始终显示原价 - 结束

            if (isBulkDiscount || subscribeStatus === 'subscribe') {
                // Apply discount: bulk discount (5%) or subscription discount
                const discountPercent = isBulkDiscount ? bulkDiscountPercent : priceData.discount.value;

                /* [ENABLE BULK DISCOUNT] 取消注释以下代码块来启用折扣价格显示
                matchVariantItem.innerHTML = '$' + (variant.price / 100 * (100 - discountPercent) / 100).toFixed(2);
                let pricePerValue = (unitPrice / 100 * (100 - discountPercent))
                // Save original value for V2 price calculation (in cents)
                const pricePerValueCents = pricePerValue;

                if (isIncluded) {
                    return
                }
                if (pricePerValue >= 100) {
                    pricePerValue = pricePerValue / 100;
                    matchvariantPricePer.innerHTML = '$' + pricePerValue.toFixed(2) + ' per ' + measuringUnit;
                }
                else {
                    matchvariantPricePer.innerHTML = '￠' + pricePerValue.toFixed(2) + ' per ' + measuringUnit;
                }
                [ENABLE BULK DISCOUNT] 结束 */

                // V2 价格元素仍然显示折扣价格
                let pricePerValue = (unitPrice / 100 * (100 - discountPercent))
                const pricePerValueCents = pricePerValue;

                if (matchvariantV2Quantity) {
                    const unit = matchedQuantityText.split('/')[1] || '';
                    matchvariantV2Quantity.innerHTML = unit ? unit.charAt(0).toUpperCase() + unit.slice(1) : '';
                }
                if (matchVariantV2Price) {
                    // Parse unit from option, e.g., "100 sets/carton" -> "Set", "100sets/carton" -> "Set", "100/carton" -> "Each"
                    const quantityPart = matchedQuantityText.split('/')[0] || '';
                    // Match pattern like "100 sets", "100sets" or "50 pairs" - unit word after number (with or without space)
                    const unitMatch = quantityPart.match(/^\d+\s*([a-zA-Z]+)/);
                    let priceUnit = 'Each';
                    if (unitMatch && unitMatch[1]) {
                        // Capitalize first letter, e.g., "sets" -> "Set"
                        priceUnit = unitMatch[1].charAt(0).toUpperCase() + unitMatch[1].slice(1).toLowerCase();
                        // Remove trailing 's' for singular form
                        if (priceUnit.endsWith('s') && priceUnit.length > 1) {
                            priceUnit = priceUnit.slice(0, -1);
                        }
                    }
                    // Use original cents value, divide by 100 to get dollars
                    const pricePerValueDollars = pricePerValueCents / 100;
                    matchVariantV2Price.innerHTML = '$' + pricePerValueDollars.toFixed(2) + '/' + priceUnit;

                }

                // Update productLabelQuantity if this is the current variant
                if (variant.id === newVariant.id && productLabelQuantity && matchvariantV2Quantity && matchVariantV2Price) {
                    const priceText = matchVariantV2Price.innerHTML;
                    if (productHeaderPerPrice) {
                        productHeaderPerPrice.innerHTML = priceText;
                    }
                }


            }
            else {

                // V2 元素显示原价
                let pricePerValue = unitPrice;
                // Save original value for V2 price calculation (in cents)
                const pricePerValueCents = pricePerValue;

                if (matchvariantV2Quantity) {
                    const unit = matchedQuantityText.split('/')[1] || '';
                    matchvariantV2Quantity.innerHTML = unit ? unit.charAt(0).toUpperCase() + unit.slice(1) : '';
                }

                if (matchVariantV2Price) {
                    // Parse unit from option, e.g., "100 sets/carton" -> "Set", "100sets/carton" -> "Set", "100/carton" -> "Each"
                    const quantityPart = matchedQuantityText.split('/')[0] || '';
                    // Match pattern like "100 sets", "100sets" or "50 pairs" - unit word after number (with or without space)
                    const unitMatch = quantityPart.match(/^\d+\s*([a-zA-Z]+)/);
                    let priceUnit = 'Each';
                    if (unitMatch && unitMatch[1]) {
                        // Capitalize first letter, e.g., "sets" -> "Set"
                        priceUnit = unitMatch[1].charAt(0).toUpperCase() + unitMatch[1].slice(1).toLowerCase();
                        // Remove trailing 's' for singular form
                        if (priceUnit.endsWith('s') && priceUnit.length > 1) {
                            priceUnit = priceUnit.slice(0, -1);
                        }
                    }
                    // Use original cents value, divide by 100 to get dollars
                    const pricePerValueDollars = pricePerValueCents / 100;
                    matchVariantV2Price.innerHTML = '$' + pricePerValueDollars.toFixed(2) + '/' + priceUnit;

                }

                // Update productLabelQuantity if this is the current variant
                if (variant.id === newVariant.id && productLabelQuantity && matchvariantV2Quantity && matchVariantV2Price) {
                    const priceText = matchVariantV2Price.innerHTML;
                    if (productHeaderPerPrice) {
                        productHeaderPerPrice.innerHTML = priceText;
                    }
                }

            }
            if (highestMatchingVariantUnitPrice > unitPrice && unitPrice > 0) {
                const percentageCheaper = Math.round(((highestMatchingVariantUnitPrice - unitPrice) / highestMatchingVariantUnitPrice) * 100);
                if (matchvariantPricePerFlag) {
                    if (index === lastAvailableIndex) {
                        //获取matchvariantPricePerFlag的data-template-suffix属性
                        const templateSuffix = matchvariantPricePerFlag.getAttribute('data-template-suffix');
                        if (templateSuffix === 'free-shipping') {
                            matchvariantPricePerFlag.innerHTML = 'cheaper in bulk!';

                        } else {
                            matchvariantPricePerFlag.innerHTML = percentageCheaper + '% cheaper in bulk!';

                        }
                    } else {
                        matchvariantPricePerFlag.innerHTML = '';
                    }
                }
            } else {
                if (matchvariantPricePerFlag) {
                    matchvariantPricePerFlag.innerHTML = '';
                }
            }

            // Flag updating class will be removed globally below
        }
    });

    // Remove flag updating class from ALL flags after update
    setTimeout(() => {
        variantPricePerFlag.forEach(flag => {
            if (flag) flag.classList.remove('flag-updating');
        });
    }, 50);

    // Remove variant group updating class after animation completes
    // Use shorter delay to show options and prices simultaneously
    // BUT: Don't remove if this is modal context initial load (handled by renderInitialVariant)
    if (!window.G_skipAnimationRemoval) {
        setTimeout(() => {
            removeVariantGroupAnimation();
        }, 150);
    }

    // matchingVariants.forEach((variant, index) => {
    //     if (!variant.available && index < variantOptionQuantity.length) {
    //         variantOptionQuantity[index].style.display = 'none';
    //     }
    // });
    // for (let i = matchingVariants.length; i < variantItems.length; i++) {
    //     variantItems[i].innerHTML = '';
    //     variantPricePer[i].innerHTML = '';
    //     variantPricePerFlag[i].innerHTML = '';
    // }
    quantitySort()

}

// 获取 URL 参数中的 variant id
function getVariantIdFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get('variant');
}

// 自动渲染初始变体（优先 URL 参数中的 variant）
function renderInitialVariant(productData, isModalContext = false) {
    if (productData && productData.variants && productData.variants.length > 0) {
        let initialVariant = null;
        const variantIdFromUrl = getVariantIdFromUrl();
        if (variantIdFromUrl) {
            initialVariant = productData.variants.find(v => String(v.id) === String(variantIdFromUrl));
        }
        if (!initialVariant) {
            initialVariant = productData.variants.find(v => v.available);

        }
        if (initialVariant) {
            // For modal context, prevent automatic animation removal
            if (isModalContext) {
                window.G_skipAnimationRemoval = true;
            }

            // Trigger initial animation for quantity group
            triggerVariantGroupAnimation();

            const event = new CustomEvent('product:variant-change', {
                detail: { variant: initialVariant, isInitialLoad: true, isModalContext: isModalContext }
            });
            document.dispatchEvent(event);

            // For modal context, ensure all processing completes before removing loading
            if (isModalContext) {
                // Step 1: Wait for variant change and unit price calculation to complete
                setTimeout(() => {
                    // console.log('Step 1 complete: Variant matched, unit prices calculated');

                    // Step 2: Trigger auto-select
                    autoSelectFirstVariant();
                    // console.log('Step 2 complete: Auto-select triggered');

                    // Step 3: Wait for auto-select to fully complete, then show content
                    setTimeout(() => {
                        // Finally remove loading animation and show all content
                        window.G_skipAnimationRemoval = false;
                        removeVariantGroupAnimation();
                        // console.log('Step 3 complete: All processing done, content visible');
                    }, 250);
                }, 350);
            }
        } else {
        }
    }
}

function initializeSwatchHoverListeners() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    document.querySelectorAll('.product-swatches-options__list').forEach(ul => {
        let originalImgSrc = null;
        let originalImgSrcset = null;
        let originalImgAlt = null;

        const swatches = ul.querySelectorAll('li');

        swatches.forEach(swatch => {
            if (!isMobile) {
                // PC端悬停预览
                swatch.addEventListener('mouseenter', function () {
                    const swatchImage = this.getAttribute('data-swatch-image');
                    const imgElement = this.closest('.product-item__inner')?.querySelector('.product-item__image--two img');
                    if (imgElement && swatchImage) {
                        if (originalImgSrc === null) {
                            originalImgSrc = imgElement.src;
                            originalImgSrcset = imgElement.srcset;
                            originalImgAlt = imgElement.alt;
                        }
                        let smallImg = swatchImage;
                        if (!/width=/.test(smallImg)) {
                            smallImg += (smallImg.includes('?') ? '&' : '?') + 'width=32';
                        }
                        imgElement.src = smallImg;
                        imgElement.srcset = smallImg + ' 1x, ' + swatchImage + ' 2x';
                        imgElement.alt = this.getAttribute('data-swatch-alt') || '';
                    }
                });
            }
            // 所有端点击切换主图和预览
            swatch.addEventListener('click', function () {

                const parentList = this.closest('.product-swatches-options__list');
                if (parentList) {
                    parentList.querySelectorAll('li.is-selected').forEach(selected => {
                        selected.classList.remove('is-selected');
                    });
                }
                this.classList.add('is-selected');

                const swatchImage = this.getAttribute('data-swatch-image');
                let imgElement;
                if (isMobile) {
                    imgElement = this.closest('.product-item__inner')?.querySelector('.product-item__image--one img');
                } else {
                    imgElement = this.closest('.product-item__inner')?.querySelector('.product-item__image--two img');
                }
                if (imgElement && swatchImage) {
                    let smallImg = swatchImage;
                    if (!/width=/.test(smallImg)) {
                        smallImg += (smallImg.includes('?') ? '&' : '?') + 'width=32';
                    }
                    imgElement.src = smallImg;
                    imgElement.srcset = smallImg + ' 1x, ' + swatchImage + ' 2x';
                    imgElement.alt = this.getAttribute('data-swatch-alt') || '';
                    // 覆盖originalImgSrc为当前图片
                    originalImgSrc = imgElement.src;
                    originalImgSrcset = imgElement.srcset;
                    originalImgAlt = imgElement.alt;
                }
            });
        });

        ul.addEventListener('mouseleave', function () {
            const imgElement = this.closest('.product-item__inner')?.querySelector('.product-item__image--two img');
            if (imgElement && originalImgSrc) {
                imgElement.src = originalImgSrc;
                imgElement.srcset = originalImgSrcset || '';
                imgElement.alt = originalImgAlt || '';
            }
            originalImgSrc = null;
            originalImgSrcset = null;
            originalImgAlt = null;
        });
    });
}

function initializeModalScrollLock() {
    const quickProductModal = document.querySelector('[data-quick-product-modal]');
    if (quickProductModal) {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const oldClassList = mutation.oldValue || '';
                    const newClassList = mutation.target.classList.toString();

                    const wasVisible = oldClassList.includes('is-visible');
                    const isVisible = newClassList.includes('is-visible');

                    if (wasVisible && !isVisible) {
                        // The modal was just closed, so we emit the close event
                        if (quickProductModal.dataset.quickProductType === 'quick-add') {
                            const event = new CustomEvent('quick-add:close');
                            document.dispatchEvent(event);
                        } else if (quickProductModal.dataset.quickProductType === 'quick-view') {
                            const event = new CustomEvent('quick-view:close');
                            document.dispatchEvent(event);
                        }
                    }
                }
            }
        });

        observer.observe(quickProductModal, {
            attributes: true,
            attributeOldValue: true
        });
    }

    let previousScrollY = 0;

    function lockBodyScroll() {
        previousScrollY = window.scrollY;
        document.documentElement.classList.add('modal-open');
        document.documentElement.style.marginTop = `-${previousScrollY}px`;
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.left = '0';
        document.documentElement.style.right = '0';
        document.documentElement.style.top = '0';
        document.documentElement.style.bottom = '0';
        document.documentElement.style.position = 'fixed';
    }

    function unlockBodyScroll() {
        // if (window.location.href.includes("products")) {
        //     console.log("unlockBodyScroll 被禁用，因为当前 URL 包含 products:", window.location.href);
        //     return;
        // }
        document.documentElement.classList.remove('modal-open');
        document.documentElement.style.marginTop = '';
        document.documentElement.style.overflow = '';
        document.documentElement.style.left = '';
        document.documentElement.style.right = '';
        document.documentElement.style.top = '';
        document.documentElement.style.bottom = '';
        document.documentElement.style.position = '';
        window.scrollTo(0, previousScrollY);
    }

    document.addEventListener('quick-add:open', function (event) {
        // console.log('quick-add:open event detected');
        lockBodyScroll();

        const data = event.detail;
        if (data && data.productUrl) {
            fetchProductData(data.productUrl);
        }
    });

    document.addEventListener('quick-add:close', function () {
        // console.log('quick-add:close event detected');
        unlockBodyScroll();
    });

    document.addEventListener('quick-view:open', function (event) {
        // console.log('quick-view:open event detected');
        lockBodyScroll();

        const data = event.detail;
        if (data && data.productUrl) {
            fetchProductData(data.productUrl);
        }
    });

    document.addEventListener('quick-view:close', function () {
        // console.log('quick-view:close event detected');
        unlockBodyScroll();
    });
}
function fetchProductData(productUrl) {
    fetch(productUrl)
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const { productData, productMetaData, productMetaMap } = getProductDataAndMeta(doc);

            if (typeof window !== 'undefined') {
                window.ProductContextCache = window.ProductContextCache || {};
                window.ProductContextCache['main'] = { productData, productMetaData, productMetaMap };
            }
        })
        .catch(error => {
        });
}
function formatMoney(cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || window.theme.moneyFormat || '${{amount}}';

    function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ',',
        decimal = '.'
    ) {
        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        default:
            value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
}

function getPriceForCurrentState() {
    const subscriptionForm = document.querySelector('[data-subscription-form]');
    if (!G_currentVariant) return null;

    // Check for bulk discount (Carton type && quantity >= 2)
    const lastOption = G_currentVariant.options[G_currentVariant.options.length - 1] || '';
    const isCarton = lastOption.toLowerCase().includes('carton');
    const quantityInput = document.querySelector('.product-form .quantity-input__input, [id^="quantity-input-product-form-"]');
    const cartQuantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    const isBulkDiscount = isCarton && cartQuantity >= 2;

    const getLbVolumeDiscountPercent = (qty) => {
        const sourceTable = getLbVolumeDiscountSourceTable();
        if (!sourceTable) return null;

        const tiers = [];
        sourceTable.querySelectorAll('tbody tr').forEach((tr) => {
            const tds = tr.querySelectorAll('td');
            if (tds.length < 2) return;

            const tierQty = parseInt((tds[0].textContent || tds[0].innerText || '').trim());
            const discountStr = ((tds[1].textContent || tds[1].innerText || '').trim() || '').replace('%', '');
            const discount = parseFloat(discountStr) || 0;

            if (!isNaN(tierQty)) tiers.push({ qty: tierQty, discount });
        });

        // 确保不仅表格存在，且至少包含一个有效折扣策略才算真的“存在”数据
        const hasValidDiscounts = tiers.some(tier => tier.discount > 0);
        if (tiers.length === 0 || !hasValidDiscounts) return null;

        tiers.sort((a, b) => a.qty - b.qty);

        let applicableDiscount = 0;
        tiers.forEach((tier) => {
            if (qty >= tier.qty) applicableDiscount = tier.discount;
        });
        return applicableDiscount;
    };

    // If lb-volume-discount exists and has valid tiers, treat it as the source of truth and ignore subscription pricing.
    // Priority: lb-volume-discount > subscription > bulk(5%) > fallback.
    if (isCarton) {
        const volumeDiscountPercent = getLbVolumeDiscountPercent(cartQuantity);
        if (volumeDiscountPercent !== null) {
            if (volumeDiscountPercent > 0) {
                // Matches tiered pricing logic: floor the discount amount in cents
                const discountAmountCents = Math.floor(G_currentVariant.price * (volumeDiscountPercent / 100));
                const discountedPrice = G_currentVariant.price - discountAmountCents;
                return {
                    price: discountedPrice,
                    compare_at_price: G_currentVariant.price,
                    discount: {
                        type: 'percent_off',
                        value: volumeDiscountPercent
                    }
                };
            }

            // Tiers exist but no discount for this quantity: do not apply the theme's bulk discount.
            return {
                price: G_currentVariant.price,
                compare_at_price: G_currentVariant.compare_at_price,
                discount: null
            };
        }
    }

    // Subscription pricing (only when lb-volume-discount is not present/valid)
    const selectedOption = subscriptionForm
        ? subscriptionForm.querySelector('[data-subscription-option]:checked')?.value ??
          subscriptionForm.querySelector('[data-subscription-option]')?.value
        : null;

    if (selectedOption === 'subscribe' && subscriptionForm) {
        const selectedPlanRadio = subscriptionForm.querySelector('[data-selling-plan-id]:checked');
        if (selectedPlanRadio && G_currentVariant.selling_plan_allocations) {
            const sellingPlanId = selectedPlanRadio.value;
            const allocation = G_currentVariant.selling_plan_allocations.find(a => a.selling_plan_id == sellingPlanId);
            if (allocation) {
                const productData = window.ProductContextCache && window.ProductContextCache.main && window.ProductContextCache.main.productData;
                const planGroup = productData && productData.selling_plan_groups && productData.selling_plan_groups[0];
                const plan = planGroup && planGroup.selling_plans && planGroup.selling_plans.find(p => p.id == sellingPlanId);

                let discount = null;
                if (plan && plan.price_adjustments && plan.price_adjustments.length > 0) {
                    const adjustment = plan.price_adjustments[0];
                    if (adjustment.value_type === 'percentage') {
                        discount = {
                            type: 'percent_off',
                            value: adjustment.value
                        };
                    }
                }
                return {
                    price: allocation.price,
                    compare_at_price: allocation.compare_at_price,
                    discount: discount
                };
            }
        }
    }

    if (isBulkDiscount) {
        // Apply 5% bulk discount using floor rounding logic to match V2 script
        const singleDiscountCents = Math.floor(G_currentVariant.price * 0.05);
        const twoItemsDiscountedTotal = G_currentVariant.price * 2 - singleDiscountCents * 2;
        const discountedPrice = twoItemsDiscountedTotal / 2;
        
        return {
            price: discountedPrice,
            compare_at_price: G_currentVariant.price,
            discount: {
                type: 'percent_off',
                value: 5
            }
        };
    }

    // Fallback to one-time purchase price
    let discount = null;
    if (G_currentVariant.compare_at_price > G_currentVariant.price) {
        const percentage = Math.round(
            ((G_currentVariant.compare_at_price - G_currentVariant.price) * 100) / G_currentVariant.compare_at_price
        );
        discount = {
            type: 'percent_off',
            value: percentage
        };
    }
    return {
        price: G_currentVariant.price,
        compare_at_price: G_currentVariant.compare_at_price,
        discount: discount
    };
}

function updateDisplayPrice() {
    // debugger;
    const priceData = getPriceForCurrentState();
    if (!priceData) return;
    // console.log('Updating display price with data:', priceData);
    const productContainer = document.querySelector('[data-section-type="product"]');
    if (!productContainer) return;

    // Hide price elements before updating
    hidePriceElements();
    const priceElements = productContainer.querySelectorAll('.product__price [data-price]');
    const comparePriceElements = productContainer.querySelectorAll('.product__price [data-compare-price], .sticky-atc-bar__price [data-compare-price]');
    const discountElements = productContainer.querySelectorAll('[data-discount-display]');

    const stickypriceEl = productContainer.querySelectorAll('.sticky-atc-bar__price [data-price]');

    // Update prices after a brief delay
    setTimeout(() => {
        priceElements.forEach(el => el.innerHTML = formatMoney(priceData.price));
        const hasDiscount = priceData.compare_at_price > priceData.price;
        // console.log("hasDiscount",hasDiscount)
        stickypriceEl.forEach(el => {
            el.innerHTML = formatMoney(priceData.price)
            if (hasDiscount) {
                el.classList.add('data-price-red');
            } else {
                el.classList.remove('data-price-red');
            }
        });
        comparePriceElements.forEach(el => el.innerHTML = priceData.compare_at_price > priceData.price ? formatMoney(priceData.compare_at_price) : '');

        discountElements.forEach(el => {
            const badge = el.querySelector('.displayed-discount');
            if (priceData.discount && priceData.discount.type === 'percent_off') {
                let discountText = `${priceData.discount.value}% off`;

                if (badge) badge.textContent = discountText;
                el.dataset.hasDiscount = 'true';
            } else {
                if (badge) badge.textContent = '';
                el.dataset.hasDiscount = 'false';
            }
        });

        // Show price elements with animation
        showPriceElements();
    }, 100);
}

let quantitySort = (forceSelectFirst = false) => {
    const quantityContainer = document.querySelector('.variant-option-container-quantity');
    if (!quantityContainer) {
        return;
    }

    const quantityButtons = Array.from(quantityContainer.querySelectorAll('.variant-option-quantity'));

    const templateSuffixEl = document.querySelector('[data-template-suffix]');
    const isV2 = templateSuffixEl && templateSuffixEl.getAttribute('data-template-suffix') === 'v2';

    const sortedButtons = quantityButtons.sort((a, b) => {
        const labelA = (a.ariaLabel || '').toLowerCase();
        const labelB = (b.ariaLabel || '').toLowerCase();

        if (!isV2) {
            const isCartonA = labelA.includes('carton');
            const isCartonB = labelB.includes('carton');

            if (isCartonA && !isCartonB) return -1;
            if (!isCartonA && isCartonB) return 1;
        }

        const valA = parseInt(a.ariaLabel, 10) || 0;
        const valB = parseInt(b.ariaLabel, 10) || 0;
        return valA - valB;
    });

    sortedButtons.forEach(button => {
        quantityContainer.appendChild(button);
    });
}

document.addEventListener('DOMContentLoaded', function () {
    // 初始化缓存
    const { productData, productMetaData, productMetaMap } = getProductDataAndMeta(document);
    if (typeof window !== 'undefined') {
        window.ProductContextCache = window.ProductContextCache || {};
        window.ProductContextCache['main'] = { productData, productMetaData, productMetaMap };
    }

    // Track clicks on variant buttons to detect which option group was clicked
    document.addEventListener('click', function (e) {
        const variantButton = e.target.closest('.dynamic-variant-button');
        if (variantButton) {
            const optionContainer = variantButton.closest('[class*="variant-option-container-"]');
            if (optionContainer) {
                // Extract option name from class (e.g., "variant-option-container-quantity" -> "quantity")
                const classList = Array.from(optionContainer.classList);
                const containerClass = classList.find(cls => cls.startsWith('variant-option-container-'));
                if (containerClass) {
                    G_lastClickedOptionGroup = containerClass.replace('variant-option-container-', '');
                }
            }
        }
    }, true); // Use capture phase to catch it early


    document.addEventListener('product:variant-change', function (event) {
        G_currentVariant = event.detail.variant;
        G_lbVolumeLastPriceKey = null;
        ensureLbVolumeDiscountObserver();
        // App tiers may update after the variant-change event; do one delayed refresh as well.
        setTimeout(refreshLbVolumeDiscountDependentUI, 250);

        // Check if this is modal context and initial load
        const isModalContext = event.detail.isModalContext || false;
        const isInitialLoadEvent = event.detail.isInitialLoad || false;

        // Only trigger animation if the change is NOT from quantity group
        const isQuantityChange = G_lastClickedOptionGroup === 'quantity';

        // For initial load, we want the animation regardless
        if (!isQuantityChange && !G_isInitialLoad) {
            // Trigger animation BEFORE handleVariantChange to prevent flash
            triggerVariantGroupAnimation();
        }

        // Reset the tracked option group
        const wasQuantityChange = isQuantityChange; // Store before resetting
        G_lastClickedOptionGroup = null;

        handleVariantChange(event, 'main');

        // Only update display price if NOT a quantity change
        // (quantity changes already handled by theme.js updatePrices)
        // Also skip on initial load as theme.js handles it
        // if (!wasQuantityChange && !G_isInitialLoad) {

        // setTimeout(() => {
        // }, 100);    
        updateDisplayPrice();

        // }

        // For modal context initial load, DON'T remove animation here
        // It will be removed after auto-select completes
        if (!isModalContext || !isInitialLoadEvent) {
            // Mark that initial load is complete for non-modal contexts
            if (G_isInitialLoad) {
                G_isInitialLoad = false;
            }
        }
    });


    renderInitialVariant(productData);
    initializeSwatchHoverListeners();
    initializeModalScrollLock();
    initializeSubscriptionForm();

    initializeEnhancedVariantSystem();
    changeProductTitle()
    window.addEventListener('resize', function () {
        changeProductTitle()
    })

    // Listen for quantity input changes to recalculate prices
    // Use more specific selector to find the product form quantity input, not cart quantity
    const quantityInputEl = document.querySelector('.product-form .quantity-input__input, .product-form [data-quantity-input], [id^="quantity-input-product-form-"]');
    if (quantityInputEl) {
        // Listen for input change
        quantityInputEl.addEventListener('change', function () {
            // Trigger variant change handler to recalculate prices
            if (G_currentVariant) {
                handleVariantChange({ detail: { variant: G_currentVariant } }, 'main');
            }
        });
        // Also listen for click on add/subtract buttons within the product form
        const productForm = quantityInputEl.closest('.product-form') || quantityInputEl.closest('form');
        const quantityButtons = productForm ? productForm.querySelectorAll('[data-add-quantity], [data-subtract-quantity]') : document.querySelectorAll('.product-form [data-add-quantity], .product-form [data-subtract-quantity]');
        quantityButtons.forEach(btn => {
            btn.addEventListener('click', function () {
                // Small delay to allow the input value to update
                setTimeout(() => {
                    if (G_currentVariant) {
                        handleVariantChange({ detail: { variant: G_currentVariant } }, 'main');
                    }
                }, 50);
            });
        });
    }

    let isSafari = () => {
        const userAgent = navigator.userAgent;
        const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        const isMac = /Macintosh/.test(userAgent);
        const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
        if (isIOS || (isMac && isSafari)) {
            document.body.classList.add('is-apple-webkit');
        }
    }
    isSafari();

    // 监听主题的 'product:variant-change' 事件
    document.addEventListener('product:variant-change', function (event) {
        //   console.log(`[${new Date().toISOString()}] Event 'product:variant-change' fired.`);

        setTimeout(() => {
            // console.log(`[${new Date().toISOString()}] setTimeout callback triggered. Running autoSelectAllAvailableOptions...`);
            autoSelectAllAvailableOptions();
        }, 100);
    });
});

// Reinitialize for Shopify theme editor
if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
        // Check if the loaded section is a product section
        if (event.target.querySelector('[data-section-type="product"]') ||
            event.target.querySelector('[data-subscription-form]')) {

            // Wait for DOM to be fully ready
            setTimeout(() => {
                // Reinitialize cache
                const { productData, productMetaData, productMetaMap } = getProductDataAndMeta(document);
                if (typeof window !== 'undefined') {
                    window.ProductContextCache = window.ProductContextCache || {};
                    window.ProductContextCache['main'] = { productData, productMetaData, productMetaMap };
                }

                // Reinitialize components
                renderInitialVariant(productData);
                initializeSubscriptionForm();
                initializeEnhancedVariantSystem();
                updateDisplayPrice();
            }, 300);
        }
    });
}

function changeProductTitle() {
    const productTitle = document.querySelectorAll('.main-product-section .product__title');
    if (productTitle.length >= 2) {
        // console.log(productTitle, productTitle[0].tagName, productTitle[1].tagName);
        if (window.innerWidth < 976 && productTitle[0].tagName === 'P' && productTitle[1].tagName === 'H1') {
            replaceTag(productTitle[0], 'h1');
            replaceTag(productTitle[1], 'p');
            // console.log('Replaced tags for mobile view');
        }
        if (window.innerWidth >= 976 && productTitle[0].tagName === 'H1' && productTitle[1].tagName === 'P') {
            replaceTag(productTitle[0], 'p');
            replaceTag(productTitle[1], 'h1');
            // console.log('Replaced tags for desktop view');
        }
    }
}
function replaceTag(oldElement, newTagName) {
    const newElement = document.createElement(newTagName);
    for (const attr of oldElement.attributes) {
        newElement.setAttribute(attr.name, attr.value);
    }
    while (oldElement.firstChild) {
        newElement.appendChild(oldElement.firstChild);
    }
    oldElement.parentNode.replaceChild(newElement, oldElement);
    return newElement;
}
function initializeSubscriptionForm() {
    const subscriptionForm = document.querySelector('[data-subscription-form]');
    if (!subscriptionForm) {
        return;
    }

    const sellingPlanInput = subscriptionForm.querySelector('input[name="selling_plan"]');
    const productForm = document.querySelector(`form[data-product-handle]`);

    if (productForm && sellingPlanInput) {
        productForm.appendChild(sellingPlanInput);
    }
    bindSubscriptionEvents(subscriptionForm, sellingPlanInput);
}

function bindSubscriptionEvents(subscriptionForm, sellingPlanInput) {
  const subscriptionOptions = subscriptionForm.querySelectorAll('[data-subscription-option]');
  const sellingPlanRadioButtons = subscriptionForm.querySelectorAll('[data-selling-plan-id]');

    // Helper to get selected option value (compatible with both radio and hidden input)
    const getSelectedOption = () => {
        return subscriptionForm.querySelector('[data-subscription-option]:checked')?.value
            ?? subscriptionForm.querySelector('[data-subscription-option]')?.value;
    };

  function updateSellingPlan() {
    const selectedOption = getSelectedOption();

    if (selectedOption === 'subscribe') {
        const selectedPlan = subscriptionForm.querySelector('[data-selling-plan-id]:checked');
        if (selectedPlan) {
            sellingPlanInput.value = selectedPlan.value;
        }
    } else {
        sellingPlanInput.value = '';
    }

    // Trigger price animation immediately
    hidePriceElements();

        // Update prices after animation starts
        setTimeout(() => {
            updateDisplayPrice();
            handleVariantChange(null, contextKey = 'main');

            // Show prices after update
            setTimeout(() => {
                showPriceElements();
            }, 50);
        }, 100);
    }

    subscriptionOptions.forEach(option => {
        option.addEventListener('change', updateSellingPlan);
    });

    sellingPlanRadioButtons.forEach(radio => {
        radio.addEventListener('change', updateSellingPlan);
    });

    // Initial state - call without animation
  const initialUpdate = () => {
    const selectedOption = getSelectedOption();
    if (selectedOption === 'subscribe') {
        const selectedPlan = subscriptionForm.querySelector('[data-selling-plan-id]:checked');
        if (selectedPlan) {
            sellingPlanInput.value = selectedPlan.value;
        }
    } else {
        sellingPlanInput.value = '';
    }
    updateDisplayPrice();
  };
  initialUpdate();
}

function enableDragToScroll(slider) {
    if (!slider) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let hasDragged = false;
    let walk = 0;
    let animationFrameId = null;

    const updateScroll = () => {
        if (!isDown) return;
        slider.scrollLeft = scrollLeft - walk;
        animationFrameId = requestAnimationFrame(updateScroll);
    };

    const startDragging = (e) => {
        isDown = true;
        hasDragged = false;

        // Add styles for better UX during drag
        slider.style.cursor = 'grabbing';
        slider.style.userSelect = 'none';
        slider.style.scrollBehavior = 'auto';

        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        walk = 0;

        // Cancel any existing animation frame and start a new one
        cancelAnimationFrame(animationFrameId);
        animationFrameId = requestAnimationFrame(updateScroll);
    };

    const stopDragging = () => {
        if (!isDown) return;
        isDown = false;

        // Remove temporary styles
        slider.style.cursor = 'grab';
        slider.style.removeProperty('user-select');
        slider.style.removeProperty('scroll-behavior');

        // Stop the animation frame loop
        cancelAnimationFrame(animationFrameId);
    };

    const onDrag = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        walk = x - startX;

        if (Math.abs(walk) > 5) { // Use a small threshold to confirm dragging
            hasDragged = true;
        }
    };

    // Event Listeners
    slider.addEventListener('mousedown', startDragging);
    slider.addEventListener('mouseup', stopDragging);
    slider.addEventListener('mouseleave', stopDragging);
    slider.addEventListener('mousemove', onDrag);

    // Prevent click event on child elements after a drag action
    slider.addEventListener('click', (e) => {
        if (hasDragged) {
            e.preventDefault();
            e.stopPropagation();
        }
    }, true); // Use capture phase to catch the event early
}
let changeGridAutoRows = function (flexItems, flexInner) {
    let isItemHeightAuto = flexInner.getAttribute('data-is-item-height-auto') === 'true';
    let gridMode = flexInner.style.getPropertyValue('--grid-mode') || 'grid';
    if (!isItemHeightAuto) {
        if (window.innerWidth < 900) {
            flexInner.style.gridAutoRows = `var(--item-height-mobile, 200px)`;
            if (gridMode === 'slider') {
                flexItems.forEach((flexItem) => {
                    flexItem.style.height = `var(--item-height-mobile, 200px)`;
                });
            } else {
                flexItems.forEach((flexItem) => {
                    flexItem.style.height = '';
                });
            }
        } else {
            flexInner.style.gridAutoRows = `var(--item-height, 200px)`;
            if (gridMode === 'slider') {
                flexItems.forEach((flexItem) => {
                    flexItem.style.height = `var(--item-height, 200px)`;
                });
            } else {
                flexItems.forEach((flexItem) => {
                    flexItem.style.height = '';
                });
            }
        }
        return;
    }
    let gridColumnNum = parseInt(flexInner.style.getPropertyValue('--grid-column-num')) || 4;
    let gridColumnNumMobile = parseInt(flexInner.style.getPropertyValue('--grid-column-num-mobile')) || 2;
    if (flexItems.length > 0) {
        let flexItem = flexItems[0];
        let percentageWidth = 0;
        if (window.innerWidth < 900) {
            percentageWidth =
                (flexInner.getBoundingClientRect().width - (gridColumnNumMobile - 1) * 16) / gridColumnNumMobile;
        } else {
            percentageWidth = (flexInner.getBoundingClientRect().width - (gridColumnNum - 1) * 16) / gridColumnNum;
        }

        flexInner.style.gridAutoRows = `${percentageWidth}px`;
    }
};

// Simple Enhanced Variant System - Minimal interference approach
function initializeSimpleVariantEnhancement() {

    function getProductDataFromCache() {
        return (typeof window !== 'undefined' && window.ProductContextCache && window.ProductContextCache['main'] && window.ProductContextCache['main'].productData) || null;
    }

    function getTemplateIsV2() {
        const templateSuffixEl = document.querySelector('[data-template-suffix]');
        return !!(templateSuffixEl && templateSuffixEl.getAttribute('data-template-suffix') === 'v2');
    }

    function hasVariantParamInUrl() {
        try {
            return new URLSearchParams(window.location.search).has('variant');
        } catch (e) {
            return false;
        }
    }

    function getGroupOptionKey(group) {
        return String(group?.getAttribute?.('data-product-option') || '').trim(); // e.g. "option1"
    }

    function getGroupSelectedValue(group) {
        if (!group) return '';
        const selectedBtn = group.querySelector('.dynamic-variant-button.selected:not(.disabled)');
        const btnVal = selectedBtn?.getAttribute('data-option-value') || selectedBtn?.getAttribute('aria-label');
        if (btnVal) return String(btnVal).trim();
        const select = group.querySelector('.dynamic-variant-input');
        if (select?.value) return String(select.value).trim();
        return '';
    }

    function buildSelectedOptionsByKey(optionGroups) {
        const selectedOptionsByKey = {};
        optionGroups.forEach(group => {
            const key = getGroupOptionKey(group);
            const val = getGroupSelectedValue(group);
            if (key && val) selectedOptionsByKey[key] = val;
        });
        return selectedOptionsByKey;
    }

    function findDesiredCartonValue(productData, selectedOptionsByKey, quantityKey) {
        if (!productData?.variants?.length || !quantityKey) return '';

        const hasAnyOtherSelection = Object.keys(selectedOptionsByKey).some(k => k !== quantityKey && !!selectedOptionsByKey[k]);
        if (!hasAnyOtherSelection) return '';

        const cartonCandidates = productData.variants.filter(v => {
            const qtyVal = String(v?.[quantityKey] || '').toLowerCase();
            if (!qtyVal.includes('carton')) return false;
            for (const [k, selectedVal] of Object.entries(selectedOptionsByKey)) {
                if (k === quantityKey) continue;
                if (!selectedVal) continue;
                if (String(v?.[k] || '') !== String(selectedVal)) return false;
            }
            return true;
        });

        if (cartonCandidates.length === 0) return '';
        const preferred = cartonCandidates.find(v => v.available);
        return String(preferred?.[quantityKey] || '').trim();
    }

    // Set up event listeners first
    setupSimpleVariantHandlers();

    // Helper to add/remove the updating class to all variant groups so the
    // CSS spinner/animations show while we calculate/autoselect initial options.
    function addUpdatingClassToAllGroups() {
        // Bug Fix: Only add updating class if there are available variants.
        // This prevents an infinite loading spinner on fully out-of-stock products.
        const { productData } = (typeof window !== 'undefined' && window.ProductContextCache && window.ProductContextCache['main']) || {};
        const hasAvailableVariants = productData?.variants?.some(v => v.available);

        if (!hasAvailableVariants) {
            // If no variants are available, ensure the wrapper is initialized to show controls,
            // but do not show a loading spinner.
            const wrapper = document.querySelector('.product__variants-wrapper');
            if (wrapper) {
                wrapper.classList.add('variants-initialized');
            }
            return; // Exit without adding the class
        }
        const groups = document.querySelectorAll('.dynamic-variant-input-wrap');
        groups.forEach(g => g.classList.add('variant-group--updating'));

        // Mark the wrapper as initialized so controls become visible
        const wrapper = document.querySelector('.product__variants-wrapper');
        if (wrapper) {
            wrapper.classList.add('variants-initialized');
        }
    }

    function removeUpdatingClassFromAllGroups() {
        const groups = document.querySelectorAll('.dynamic-variant-input-wrap');
        groups.forEach(g => g.classList.remove('variant-group--updating'));
    }

    // The MutationObserver has been replaced by a 'product:variant-change' event listener.

    // Auto-select first available variant on load with multiple attempts
    let attempts = 0;
    const maxAttempts = 5;

    const tryAutoSelect = () => {
        attempts++;

        const optionGroups = document.querySelectorAll('.dynamic-variant-input-wrap');
        const variantButtons = document.querySelectorAll('.dynamic-variant-button');

        // Only proceed if we have variant elements
        if (optionGroups.length > 0 && variantButtons.length > 0) {
            // Cancel any previous safety timer
            clearTimeout(window.__variant_init_safety_timeout);

            // Show spinner/animation while we do auto-selection
            addUpdatingClassToAllGroups();

            autoSelectFirstVariant();

            // Check if auto-selection worked
            setTimeout(() => {
                let hasSelections = Array.from(optionGroups).some(group =>
                    group.querySelector('.dynamic-variant-button.selected') ||
                    group.querySelector('.dynamic-variant-input')?.value
                );

                // If we expect default carton (non-v2 + no ?variant=), don't treat initialization as complete
                // unless the Quantity group actually ends up on the carton value that matches the current other selections.
                try {
                    const isV2 = getTemplateIsV2();
                    const hasVariantInUrl = hasVariantParamInUrl();
                    const quantityGroup = document.querySelector('.variant-option-container-quantity.dynamic-variant-input-wrap') ||
                        document.querySelector('.variant-option-container-quantity .dynamic-variant-input-wrap') ||
                        document.querySelector('.variant-option-container-quantity');
                    const shouldForceCarton = !isV2 && !!quantityGroup && !hasVariantInUrl;

                    if (shouldForceCarton) {
                        const productData = getProductDataFromCache();
                        const selectedOptionsByKey = buildSelectedOptionsByKey(Array.from(optionGroups));
                        const quantityKey = getGroupOptionKey(quantityGroup);
                        const desiredCartonValue = findDesiredCartonValue(productData, selectedOptionsByKey, quantityKey);
                        const currentQuantityValue = getGroupSelectedValue(quantityGroup);
                        if (desiredCartonValue && currentQuantityValue !== desiredCartonValue) {
                            hasSelections = false;
                        }
                    }
                } catch (e) {
                    // ignore
                }

                // If no selections were made and we haven't reached max attempts, try again
                if (!hasSelections && attempts < maxAttempts) {
                    setTimeout(tryAutoSelect, 300);
                } else {
                    // Either we have selections or reached max attempts — remove spinner
                    removeUpdatingClassFromAllGroups();
                }
            }, 200);
        } else if (attempts < maxAttempts) {
            // If elements not ready, try again
            setTimeout(tryAutoSelect, 300);
        } else {
            // Reached max attempts without finding elements — remove spinner if present
            removeUpdatingClassFromAllGroups();
        }
    };

    // Start first attempt after a short delay
    // Show spinner immediately for initial load, with a safety timeout in case
    // something prevents removal. The spinner will be cleared once auto-selection
    // completes or when the safety timeout fires.
    addUpdatingClassToAllGroups();
    setTimeout(tryAutoSelect, 300);

    // Safety fallback: remove updating class after 5 seconds to avoid
    // permanently hiding controls if something goes wrong.
    window.__variant_init_safety_timeout = setTimeout(() => {
        const groups = document.querySelectorAll('.dynamic-variant-input-wrap');
        if (groups.length) {
            groups.forEach(g => g.classList.remove('variant-group--updating'));
        }
    }, 5000);
}

function autoSelectFirstVariant() {
    quantitySort();

    const templateSuffixEl = document.querySelector('[data-template-suffix]');
    const isV2 = templateSuffixEl && templateSuffixEl.getAttribute('data-template-suffix') === 'v2';
    const hasVariantInUrl = new URLSearchParams(window.location.search).has('variant');
    const optionGroups = document.querySelectorAll('.dynamic-variant-input-wrap');

    const productData = (typeof window !== 'undefined' && window.ProductContextCache && window.ProductContextCache['main'] && window.ProductContextCache['main'].productData) || null;

    const getGroupOptionKey = (group) => String(group?.getAttribute?.('data-product-option') || '').trim();
    const getGroupSelectedValue = (group) => {
        if (!group) return '';
        const selectedBtn = group.querySelector('.dynamic-variant-button.selected:not(.disabled)');
        const btnVal = selectedBtn?.getAttribute('data-option-value') || selectedBtn?.getAttribute('aria-label');
        if (btnVal) return String(btnVal).trim();
        const select = group.querySelector('.dynamic-variant-input');
        if (select?.value) return String(select.value).trim();
        return '';
    };
    const selectedOptionsByKey = {};
    optionGroups.forEach(g => {
        const k = getGroupOptionKey(g);
        const v = getGroupSelectedValue(g);
        if (k && v) selectedOptionsByKey[k] = v;
    });

    const findDesiredCartonValue = (quantityKey) => {
        if (!productData?.variants?.length || !quantityKey) return '';
        const hasAnyOtherSelection = Object.keys(selectedOptionsByKey).some(k => k !== quantityKey && !!selectedOptionsByKey[k]);
        if (!hasAnyOtherSelection) return '';

        const cartonCandidates = productData.variants.filter(v => {
            const qtyVal = String(v?.[quantityKey] || '').toLowerCase();
            if (!qtyVal.includes('carton')) return false;
            for (const [k, selectedVal] of Object.entries(selectedOptionsByKey)) {
                if (k === quantityKey) continue;
                if (!selectedVal) continue;
                if (String(v?.[k] || '') !== String(selectedVal)) return false;
            }
            return true;
        });
        if (cartonCandidates.length === 0) return '';
        const preferred = cartonCandidates.find(v => v.available);
        return String(preferred?.[quantityKey] || '').trim();
    };

    const clickOptionValueInGroup = (group, desiredValue) => {
        if (!group || !desiredValue) return false;
        const buttons = Array.from(group.querySelectorAll('.dynamic-variant-button'));
        const matchBtn = buttons.find(btn => String(btn.getAttribute('data-option-value') || '').trim() === desiredValue);
        if (matchBtn && !matchBtn.classList.contains('disabled')) {
            matchBtn.click();
            return true;
        }
        const select = group.querySelector('.dynamic-variant-input');
        if (select) {
            const matchOption = Array.from(select.options).find(opt => String(opt.value || '').trim() === desiredValue);
            if (matchOption && !matchOption.disabled && select.value !== matchOption.value) {
                select.value = matchOption.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                return true;
            }
        }
        return false;
    };

    optionGroups.forEach((group) => {
        const existingSelection = group.querySelector('.dynamic-variant-button.selected:not(.disabled)');
        const existingSelectValue = group.querySelector('.dynamic-variant-input')?.value;

        const isQuantityGroup = group.closest('.variant-option-container-quantity');

        // 非 v2 模板 + Quantity 组 + URL 无 variant 参数时，默认选中“与当前其他组选项匹配”的可售 carton 变体
        if (!isV2 && isQuantityGroup && !hasVariantInUrl) {
            const quantityKey = getGroupOptionKey(group);
            const desiredCartonValue = findDesiredCartonValue(quantityKey);
            const currentVal = existingSelection ? String(existingSelection.getAttribute('data-option-value') || existingSelection.getAttribute('aria-label') || '').trim() : String(existingSelectValue || '').trim();
            if (desiredCartonValue && currentVal !== desiredCartonValue) {
                // 使用原生 .click() 方法触发点击，dispatchEvent 可能不会被主题事件处理器响应
                if (clickOptionValueInGroup(group, desiredCartonValue)) {
                    return;
                }
            }
        }

        if (existingSelection || existingSelectValue) {
            return;
        }

        const availableButtons = group.querySelectorAll('.dynamic-variant-button:not(.disabled)');

        if (availableButtons.length > 0) {
            const firstAvailable = availableButtons[0];
            firstAvailable.click();
            return;
        }

        const select = group.querySelector('.dynamic-variant-input');
        if (select) {
            const availableOptions = Array.from(select.options).filter(option => !option.disabled && option.value);

            if (availableOptions.length > 0 && select.value !== availableOptions[0].value) {
                select.value = availableOptions[0].value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    });
}

function setupSimpleVariantHandlers() {
    // Remove any existing listeners to avoid duplicates
    if (window.variantHandlersInitialized) {
        return;
    }
    window.variantHandlersInitialized = true;

    // Handle variant button clicks with more specific targeting
    document.addEventListener('click', function (e) {
        const variantButton = e.target.closest('.dynamic-variant-button');
        if (variantButton && !variantButton.classList.contains('disabled')) {

            autoSelectNextOptions(variantButton);
        }
    });

    // Handle variant select changes
    document.addEventListener('change', function (e) {
        const variantSelect = e.target.closest('.dynamic-variant-input');
        if (variantSelect) {

            autoSelectNextOptions(variantSelect);
        }
    });

    // Also listen for theme's variant change events to trigger auto-selection
    document.addEventListener('product:variant-change', function (e) {
        // Comprehensive check for all groups that need auto-selection
        const optionGroups = document.querySelectorAll('.dynamic-variant-input-wrap');
        let needsAutoSelection = false;

        optionGroups.forEach((group, index) => {
            const selectedButton = group.querySelector('.dynamic-variant-button.selected');
            const select = group.querySelector('.dynamic-variant-input');

            // Check if selection is invalid or missing
            const hasDisabledSelection = selectedButton?.classList.contains('disabled');
            const hasDisabledSelectOption = select && select.selectedIndex > 0 && select.options[select.selectedIndex]?.disabled;
            const hasNoSelection = !selectedButton && (!select || !select.value);

            if (hasDisabledSelection || hasDisabledSelectOption || hasNoSelection) {
                needsAutoSelection = true;
            }
        });

        if (needsAutoSelection) {
            autoSelectAllAvailableOptions();
        }
    });
}

function autoSelectAllAvailableOptions() {
    quantitySort();

    const optionGroups = document.querySelectorAll('.dynamic-variant-input-wrap');

    const templateSuffixEl = document.querySelector('[data-template-suffix]');
    const isV2 = templateSuffixEl && templateSuffixEl.getAttribute('data-template-suffix') === 'v2';
    const hasVariantInUrl = new URLSearchParams(window.location.search).has('variant');

    const productData = (typeof window !== 'undefined' && window.ProductContextCache && window.ProductContextCache['main'] && window.ProductContextCache['main'].productData) || null;
    const getGroupOptionKey = (group) => String(group?.getAttribute?.('data-product-option') || '').trim();
    const getGroupSelectedValue = (group) => {
        if (!group) return '';
        const selectedBtn = group.querySelector('.dynamic-variant-button.selected:not(.disabled)');
        const btnVal = selectedBtn?.getAttribute('data-option-value') || selectedBtn?.getAttribute('aria-label');
        if (btnVal) return String(btnVal).trim();
        const select = group.querySelector('.dynamic-variant-input');
        if (select?.value) return String(select.value).trim();
        return '';
    };

    const selectedOptionsByKey = {};
    optionGroups.forEach(g => {
        const k = getGroupOptionKey(g);
        const v = getGroupSelectedValue(g);
        if (k && v) selectedOptionsByKey[k] = v;
    });

    const findDesiredCartonValue = (quantityKey) => {
        if (!productData?.variants?.length || !quantityKey) return '';
        const hasAnyOtherSelection = Object.keys(selectedOptionsByKey).some(k => k !== quantityKey && !!selectedOptionsByKey[k]);
        if (!hasAnyOtherSelection) return '';
        const cartonCandidates = productData.variants.filter(v => {
            const qtyVal = String(v?.[quantityKey] || '').toLowerCase();
            if (!qtyVal.includes('carton')) return false;
            for (const [k, selectedVal] of Object.entries(selectedOptionsByKey)) {
                if (k === quantityKey) continue;
                if (!selectedVal) continue;
                if (String(v?.[k] || '') !== String(selectedVal)) return false;
            }
            return true;
        });
        if (cartonCandidates.length === 0) return '';
        const preferred = cartonCandidates.find(v => v.available);
        return String(preferred?.[quantityKey] || '').trim();
    };

    optionGroups.forEach((group, index) => {
        const selectedButton = group.querySelector('.dynamic-variant-button.selected');
        const select = group.querySelector('.dynamic-variant-input');

        const hasValidSelection = (selectedButton && !selectedButton.classList.contains('disabled')) ||
            (select && select.value && select.selectedIndex > 0 && !select.options[select.selectedIndex]?.disabled);

        if (!hasValidSelection) {
            if (selectedButton && selectedButton.classList.contains('disabled')) {
                selectedButton.classList.remove('selected');
            }

            const isQuantityGroup = !!group.closest('.variant-option-container-quantity');
            const shouldForceCarton = !isV2 && isQuantityGroup && !hasVariantInUrl;

            if (shouldForceCarton) {
                const quantityKey = getGroupOptionKey(group);
                const desiredCartonValue = findDesiredCartonValue(quantityKey);
                if (desiredCartonValue) {
                    const buttons = Array.from(group.querySelectorAll('.dynamic-variant-button'));
                    const matchBtn = buttons.find(btn => String(btn.getAttribute('data-option-value') || '').trim() === desiredCartonValue);
                    if (matchBtn && !matchBtn.classList.contains('disabled')) {
                        matchBtn.click();
                        return;
                    }
                }
            }

            const availableButtons = group.querySelectorAll('.dynamic-variant-button:not(.disabled)');
            if (availableButtons.length > 0) {
                const firstAvailable = availableButtons[0];
                firstAvailable.click();
            } else if (select) {
                const availableOptions = Array.from(select.options).filter(option => !option.disabled && option.value);
                if (availableOptions.length > 0) {
                    select.value = availableOptions[0].value;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }
    });
}


function autoSelectNextOptions(changedElement) {
    const optionGroups = document.querySelectorAll('.dynamic-variant-input-wrap');
    const changedGroup = changedElement.closest('.dynamic-variant-input-wrap');
    const changedIndex = Array.from(optionGroups).indexOf(changedGroup);

    setTimeout(() => {
        quantitySort();

        const templateSuffixEl = document.querySelector('[data-template-suffix]');
        const isV2 = templateSuffixEl && templateSuffixEl.getAttribute('data-template-suffix') === 'v2';
        const hasVariantInUrl = new URLSearchParams(window.location.search).has('variant');

        const productData = (typeof window !== 'undefined' && window.ProductContextCache && window.ProductContextCache['main'] && window.ProductContextCache['main'].productData) || null;
        const getGroupOptionKey = (group) => String(group?.getAttribute?.('data-product-option') || '').trim();
        const getGroupSelectedValue = (group) => {
            if (!group) return '';
            const selectedBtn = group.querySelector('.dynamic-variant-button.selected:not(.disabled)');
            const btnVal = selectedBtn?.getAttribute('data-option-value') || selectedBtn?.getAttribute('aria-label');
            if (btnVal) return String(btnVal).trim();
            const select = group.querySelector('.dynamic-variant-input');
            if (select?.value) return String(select.value).trim();
            return '';
        };

        const selectedOptionsByKey = {};
        optionGroups.forEach(g => {
            const k = getGroupOptionKey(g);
            const v = getGroupSelectedValue(g);
            if (k && v) selectedOptionsByKey[k] = v;
        });

        const findDesiredCartonValue = (quantityKey) => {
            if (!productData?.variants?.length || !quantityKey) return '';
            const hasAnyOtherSelection = Object.keys(selectedOptionsByKey).some(k => k !== quantityKey && !!selectedOptionsByKey[k]);
            if (!hasAnyOtherSelection) return '';
            const cartonCandidates = productData.variants.filter(v => {
                const qtyVal = String(v?.[quantityKey] || '').toLowerCase();
                if (!qtyVal.includes('carton')) return false;
                for (const [k, selectedVal] of Object.entries(selectedOptionsByKey)) {
                    if (k === quantityKey) continue;
                    if (!selectedVal) continue;
                    if (String(v?.[k] || '') !== String(selectedVal)) return false;
                }
                return true;
            });
            if (cartonCandidates.length === 0) return '';
            const preferred = cartonCandidates.find(v => v.available);
            return String(preferred?.[quantityKey] || '').trim();
        };

        optionGroups.forEach((otherGroup, index) => {
            if (index === changedIndex) {
                return;
            }

            const selectedButton = otherGroup.querySelector('.dynamic-variant-button.selected');
            const select = otherGroup.querySelector('.dynamic-variant-input');

            const currentSelectionInvalid = selectedButton?.classList.contains('disabled') ||
                (select && select.selectedIndex > 0 && select.options[select.selectedIndex]?.disabled);
            const hasNoSelection = !selectedButton && (!select || !select.value);

            if (currentSelectionInvalid || hasNoSelection) {
                const isQuantityGroup = !!otherGroup.closest('.variant-option-container-quantity');
                const shouldForceCarton = !isV2 && isQuantityGroup && !hasVariantInUrl;

                if (shouldForceCarton) {
                    const quantityKey = getGroupOptionKey(otherGroup);
                    const desiredCartonValue = findDesiredCartonValue(quantityKey);
                    if (desiredCartonValue) {
                        const buttons = Array.from(otherGroup.querySelectorAll('.dynamic-variant-button'));
                        const matchBtn = buttons.find(btn => String(btn.getAttribute('data-option-value') || '').trim() === desiredCartonValue);
                        if (matchBtn && !matchBtn.classList.contains('disabled')) {
                            if (selectedButton) selectedButton.classList.remove('selected');
                            matchBtn.click();
                            return;
                        }
                    }
                }

                const availableButtons = otherGroup.querySelectorAll('.dynamic-variant-button:not(.disabled)');

                if (availableButtons.length > 0) {
                    const firstAvailable = availableButtons[0];

                    if (selectedButton) {
                        selectedButton.classList.remove('selected');
                    }

                    firstAvailable.click();
                } else if (select) {
                    const availableOptions = Array.from(select.options).filter(option => !option.disabled && option.value);
                    if (availableOptions.length > 0) {
                        select.value = availableOptions[0].value;
                        select.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            }
        });
    }, 100);
}

// Initialize the simple variant enhancement system
function initializeEnhancedVariantSystem() {
    // Wait for theme to be ready, then initialize our simple enhancement
    setTimeout(() => {
        initializeSimpleVariantEnhancement();

        // Also handle modals
        document.addEventListener('quick-view:open', function () {
            setTimeout(() => initializeSimpleVariantEnhancement(), 300);
        });

        document.addEventListener('quick-add:open', function () {
            setTimeout(() => initializeSimpleVariantEnhancement(), 300);
        });
    }, 500);
}

// ===== VARIANT GROUP ANIMATION FUNCTIONS =====
// Trigger variant group updating animation with spinner (only for Quantity option)
function triggerVariantGroupAnimation() {
    const { productData } = (typeof window !== 'undefined' && window.ProductContextCache && window.ProductContextCache['main']) || {};
    const hasAvailableVariants = productData?.variants?.some(v => v.available);

    if (!hasAvailableVariants) {
        return; // Exit without adding the class
    }
    // Only target the Quantity option group (last controls group)
    const quantityGroup = document.querySelector('.variant-option-container-quantity');

    if (quantityGroup) {
        quantityGroup.classList.add('variant-group--updating');
    }

    // Also trigger price hide animation
    hidePriceElements();
}

// Remove variant group updating animation (only for Quantity option)
function removeVariantGroupAnimation() {
    // Only target the Quantity option group (last controls group)
    const quantityGroup = document.querySelector('.variant-option-container-quantity');

    if (quantityGroup) {
        quantityGroup.classList.remove('variant-group--updating');
    }

    // Also trigger price show animation
    showPriceElements();
}

// Hide price elements with instant animation
function hidePriceElements() {
    const priceContainers = document.querySelectorAll('.product__price, .sticky-atc-bar__price');

    priceContainers.forEach(container => {
        container.classList.add('product__price--unavailable', 'price--unavailable');
    });
}

// Show price elements with smooth animation
function showPriceElements() {
    const priceContainers = document.querySelectorAll('.product__price, .sticky-atc-bar__price');

    // Remove delay to show prices simultaneously with quantity options
    priceContainers.forEach(container => {
        container.classList.remove('product__price--unavailable', 'price--unavailable');
    });
}

// 自动播放缩略图点击的视频
document.addEventListener("click", (event) => {
    const thumb = event.target.closest("[data-product-thumbnail]");
    if (!thumb) return;

    const mediaId = thumb.getAttribute("data-thumbnail-id");
    setTimeout(() => {
        const targetMedia = document.querySelector(`.media--has-lightbox[data-media-id="${mediaId}"]`);
        if (!targetMedia) return;

        const targetVideo = targetMedia.querySelector(`.media video`);
        if (!targetVideo) return;
        window.lastVideoClickTime = Date.now();
        // 设置视频属性并播放
        targetVideo.muted = true;        // 必须静音才能自动播放
        targetVideo.playsInline = true;  // 移动端 inline 播放 
        targetVideo.play().catch(err => {
            console.warn("视频播放失败：", err);
        });
    }, 350); // 延迟 350ms，可根据 slider 动画调整
});

// Klaviyo 表单 H1 替换为 Span
function replaceKlaviyoH1() {
    const targetId = 'rich-text-01KAWXPT5H1C6DRGX0PKD3WTZE';
    const container = document.getElementById(targetId);
    
    if (container) {
        const h1 = container.querySelector('h1');
        if (h1) {
            const span = document.createElement('span');
            // 复制所有属性
            Array.from(h1.attributes).forEach(attr => {
                span.setAttribute(attr.name, attr.value);
            });
            // 强制设置为块级元素以保持布局
            span.style.display = 'block';
            span.style.margin = '0'; // h1 通常有 margin，如果原 h1 有 style 会覆盖这个，如果没有则重置
            
            // 移动所有子节点
            while (h1.firstChild) {
                span.appendChild(h1.firstChild);
            }
            
            // 替换元素
            h1.parentNode.replaceChild(span, h1);
            // console.log('Klaviyo H1 replaced with Span');
        }
    }
}

function syncContactFormFileUploadState(wrapper) {
    if (!wrapper) return;

    const filenameEl = wrapper.querySelector('[data-file-upload-filename]');
    const nativeInput = wrapper.querySelector('.appFileUploadNative');

    if (!filenameEl) return;

    if (!filenameEl.dataset.defaultText) {
        filenameEl.dataset.defaultText = filenameEl.textContent.trim();
    }

    const files = nativeInput && nativeInput.files ? Array.from(nativeInput.files) : [];
    const fileNames = files.map((file) => file.name).join(', ');

    wrapper.classList.toggle('has-file', files.length > 0);
    filenameEl.textContent = fileNames || filenameEl.dataset.defaultText;
}

function setupContactFormFileUploadDropzone(wrapper) {
    if (!wrapper || wrapper.dataset.fileUploadDropzoneReady) return;
    wrapper.dataset.fileUploadDropzoneReady = 'true';

    const dropzone = wrapper.querySelector('[data-file-upload-dropzone]');
    const filenameEl = wrapper.querySelector('[data-file-upload-filename]');

    if (!dropzone || !filenameEl) return;

    if (!filenameEl.dataset.defaultText) {
        filenameEl.dataset.defaultText = filenameEl.textContent.trim();
    }

    const getNativeInput = () => wrapper.querySelector('.appFileUploadNative');

    const hydrateNativeInput = () => {
        const nativeInput = wrapper.querySelector('.appFileUploadNative');

        if (!nativeInput) return false;

        if (!nativeInput.dataset.fileUploadDropzoneBound) {
            nativeInput.dataset.fileUploadDropzoneBound = 'true';
            nativeInput.addEventListener('change', () => syncContactFormFileUploadState(wrapper));
            nativeInput.setAttribute('aria-label', dropzone.getAttribute('aria-label') || 'Upload file');
        }

        syncContactFormFileUploadState(wrapper);
        return true;
    };

    const setDragState = (isDragging) => {
        wrapper.classList.toggle('is-dragover', isDragging);
    };

    ['dragenter', 'dragover'].forEach((eventName) => {
        dropzone.addEventListener(eventName, (event) => {
            event.preventDefault();
            if (event.dataTransfer) {
                event.dataTransfer.dropEffect = 'copy';
            }
            setDragState(true);
        });
    });

    ['dragleave', 'dragend', 'drop'].forEach((eventName) => {
        dropzone.addEventListener(eventName, (event) => {
            if (eventName === 'dragleave' && event.relatedTarget && dropzone.contains(event.relatedTarget)) {
                return;
            }
            setDragState(false);
        });
    });

    dropzone.addEventListener('drop', (event) => {
        event.preventDefault();
        setDragState(false);

        const nativeInput = getNativeInput();
        const droppedFiles = event.dataTransfer?.files;

        if (!nativeInput || !droppedFiles || droppedFiles.length === 0) return;

        try {
            nativeInput.files = droppedFiles;
        } catch (error) {
            try {
                const transfer = new DataTransfer();
                Array.from(droppedFiles).forEach((file) => transfer.items.add(file));
                nativeInput.files = transfer.files;
            } catch (fallbackError) {
                return;
            }
        }

        nativeInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    dropzone.addEventListener('click', () => {
        const nativeInput = getNativeInput();
        if (nativeInput) {
            nativeInput.click();
        }
    });

    dropzone.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        const nativeInput = getNativeInput();
        if (nativeInput) {
            nativeInput.click();
        }
    });

    if (!hydrateNativeInput()) {
        const observer = new MutationObserver(() => {
            if (hydrateNativeInput()) {
                observer.disconnect();
            }
        });

        observer.observe(wrapper, {
            childList: true,
            subtree: true,
        });
    }
}

function initContactFormFileUploadDropzones(root = document) {
    const wrappers = root.querySelectorAll('.contact-form__input-wrapper--file-upload');
    wrappers.forEach(setupContactFormFileUploadDropzone);
}

function createRyviuScrollSliderNavButton(direction) {
    const wrapper = document.createElement('div');
    wrapper.className = `scroll-slider-nav-button-wrapper scroll-slider-nav-button-wrapper--${direction}`;
    wrapper.dataset.isSmall = 'false';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = `scroll-slider-nav-button scroll-slider-nav-button--${direction} hidden`;
    button.title = direction === 'prev' ? 'Previous' : 'Next';
    button.name = direction;
    button.setAttribute(`data-scroll-slider-${direction}-button`, '');
    button.innerHTML = `
        <span class="icon icon-arrow-short">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 12.4016H11.5H23M23 12.4016L13.8 3M23 12.4016L13.8 21.8032" stroke="currentColor" stroke-width="1.75"></path>
            </svg>
        </span>
    `;

    wrapper.appendChild(button);
    return { wrapper, button };
}

function initRyviuFeatureCarouselNavigation(root = document) {
    const widgets = root.querySelectorAll('ryviu-feature-extend');
    const carousels = Array.from(widgets).flatMap((widget) => {
        const section = widget.closest('.shopify-section');
        return section ? Array.from(section.querySelectorAll('.glider-contain')) : [];
    });

    carousels.forEach((carousel) => {
        if (carousel.dataset.ryviuScrollNavInitialized === 'true') return;

        const glider = carousel.querySelector('.glider');
        const track = carousel.querySelector('.glider-track');
        if (!glider || !track) return;

        carousel.dataset.ryviuScrollNavInitialized = 'true';

        const prev = createRyviuScrollSliderNavButton('prev');
        const next = createRyviuScrollSliderNavButton('next');

        carousel.append(prev.wrapper, next.wrapper);

        const getSlides = () => Array.from(track.querySelectorAll('.r--item-view, .glider-slide'));

        const getMaxScrollLeft = () => Math.max(0, glider.scrollWidth - glider.clientWidth);

        const getSnapPoints = () => {
            const maxScrollLeft = getMaxScrollLeft();
            const slides = getSlides();
            const snapPoints = slides
                .map((slide) => {
                    const centeredOffset = slide.offsetLeft - ((glider.clientWidth - slide.offsetWidth) / 2);
                    return Math.min(maxScrollLeft, Math.max(0, centeredOffset));
                })
                .filter((point, index, points) => index === 0 || Math.abs(point - points[index - 1]) > 1);

            if (!snapPoints.length || snapPoints[0] > 1) snapPoints.unshift(0);
            if (maxScrollLeft > 1 && Math.abs(snapPoints[snapPoints.length - 1] - maxScrollLeft) > 1) {
                snapPoints.push(maxScrollLeft);
            }

            return snapPoints;
        };

        const updateButtons = () => {
            const maxScrollLeft = getMaxScrollLeft();
            const canScroll = maxScrollLeft > 1;
            const atStart = glider.scrollLeft <= 1;
            const atEnd = glider.scrollLeft >= maxScrollLeft - 1;

            [prev.button, next.button].forEach((button) => {
                button.classList.toggle('hidden', !canScroll);
            });

            prev.button.toggleAttribute('disabled', !canScroll || atStart);
            next.button.toggleAttribute('disabled', !canScroll || atEnd);
        };

        const scrollToDirection = (direction) => {
            const snapPoints = getSnapPoints();
            const current = glider.scrollLeft;
            const target = direction === 'next'
                ? snapPoints.find((point) => point > current + 1)
                : snapPoints.slice().reverse().find((point) => point < current - 1);

            glider.scrollTo({
                left: typeof target === 'number' ? target : current,
                behavior: 'smooth',
            });
        };

        prev.button.addEventListener('click', (event) => {
            event.preventDefault();
            scrollToDirection('prev');
        });

        next.button.addEventListener('click', (event) => {
            event.preventDefault();
            scrollToDirection('next');
        });

        glider.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);

        if (typeof ResizeObserver !== 'undefined') {
            const resizeObserver = new ResizeObserver(updateButtons);
            resizeObserver.observe(glider);
            resizeObserver.observe(track);
        }

        updateButtons();
        setTimeout(updateButtons, 500);
    });
}

// 初始化观察者以处理异步加载
document.addEventListener('DOMContentLoaded', function() {
    // 立即尝试一次
    replaceKlaviyoH1();
    initContactFormFileUploadDropzones(document);
    initRyviuFeatureCarouselNavigation(document);
    
    // 设置观察者
    const observer = new MutationObserver((mutations) => {
        // 检查是否有关心的节点被添加
        let shouldCheck = false;
        for (const mutation of mutations) {
            if (mutation.addedNodes.length > 0) {
                shouldCheck = true;
                break;
            }
        }
        
        if (shouldCheck) {
            const container = document.getElementById('rich-text-01KAWXPT5H1C6DRGX0PKD3WTZE');
            if (container && container.querySelector('h1')) {
                replaceKlaviyoH1();
            }

            initRyviuFeatureCarouselNavigation(document);
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
